// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/loginbackground.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!

 =========================================================
 * Light Bootstrap Dashboard React - v1.2.0
 * Based on Light Bootstrap Dashboard - v1.3.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard-react
 * Copyright 2017 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*      light colors         */
body.react-confirm-alert-body-element {
  overflow: hidden;
}

.react-confirm-alert-blur {
  filter: url(#gaussian-blur);
  filter: blur(2px);
  -webkit-filter: blur(2px);
}

.react-confirm-alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background: rgba(255, 255, 255, 0.9);
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  opacity: 0;
  animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
}

.react-confirm-alert-body {
  font-family: Arial, Helvetica, sans-serif;
  padding: 30px;
  text-align: left;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);
  color: #666;
}

.react-confirm-alert-svg {
  position: absolute;
  top: 0;
  left: 0;
}

.react-confirm-alert-body > h1 {
  margin-top: 0;  
}

.react-confirm-alert-body > h3 {
  margin: 0;
  font-size: 16px;
}

.react-confirm-alert-button-group {
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
}

.react-confirm-alert-button-group > button {
  outline: none;
  background: #337ab7;
  border: none;
  display: inline-block;
  padding: 6px 18px;
  color: #eee;
  margin-right: 10px;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
}

.react-confirm-alert-button-group > button:hover {
  outline: none;
  background: #66ace9;
  border: none;
  display: inline-block;
  padding: 6px 18px;
  color: #eee;
  margin-right: 10px;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
}

@keyframes react-confirm-alert-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/*           Font Smoothing      */
body,
h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6,
p,
.navbar,
.brand,
.btn-simple,
.alert,
a,
.td-name,
td,
button.close {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  font-weight: 400;
}
.landing {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  margin-top: -70px;
  margin-bottom: -50px;
}

.landing-inner {
  padding-top: 80px;
}

.dark-overlay {
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4 {
  font-weight: 300;
  margin: 30px 0 15px;
}

h1,
.h1 {
  font-size: 52px;
}

h2,
.h2 {
  font-size: 36px;
}

h3,
.h3 {
  font-size: 28px;
  margin: 20px 0 10px;
}

h4,
.h4 {
  font-size: 22px;
  line-height: 30px;
}

h5,
.h5 {
  font-size: 16px;
  margin-bottom: 15px;
}

h6,
.h6 {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

p {
  font-size: 16px;
  line-height: 1.5;
}

h1 small,
h2 small,
h3 small,
h4 small,
h5 small,
h6 small,
.h1 small,
.h2 small,
.h3 small,
.h4 small,
.h5 small,
.h6 small,
h1 .small,
h2 .small,
h3 .small,
h4 .small,
h5 .small,
h6 .small,
.h1 .small,
.h2 .small,
.h3 .small,
.h4 .small,
.h5 .small,
.h6 .small {
  color: #9a9a9a;
  font-weight: 300;
  line-height: 1.5;
}

h1 small,
h2 small,
h3 small,
h1 .small,
h2 .small,
h3 .small {
  font-size: 60%;
}

h1 .subtitle {
  display: block;
  margin: 0 0 30px;
}

.text-muted {
  color: #9a9a9a;
}

.text-primary,
.text-primary:hover {
  color: #1d62f0 !important;
}

.text-info,
.text-info:hover {
  color: #1dc7ea !important;
}

.text-success,
.text-success:hover {
  color: #87cb16 !important;
}

.text-warning,
.text-warning:hover {
  color: #ff9500 !important;
}

.text-danger,
.text-danger:hover {
  color: #ff4a55 !important;
}

/*     General overwrite     */
body,
.wrapper {
  min-height: 100vh;
  position: relative;
  background-color: white;
}

a {
  color: #1dc7ea;
}
a:hover,
a:focus {
  color: #42d0ed;
  text-decoration: none;
}

a:focus,
a:active,
button::-moz-focus-inner,
input::-moz-focus-inner,
input[type='reset']::-moz-focus-inner,
input[type='button']::-moz-focus-inner,
input[type='submit']::-moz-focus-inner,
select::-moz-focus-inner,
input[type='file'] > input[type='button']::-moz-focus-inner {
  outline: 0;
}

.ui-slider-handle:focus,
.navbar-toggle,
input:focus {
  outline: 0 !important;
}

/*           Animations              */
.form-control,
.input-group-addon,
.tagsinput,
.navbar,
.navbar .alert {
  transition: all 300ms linear;
}

.sidebar .nav a,
.table > tbody > tr .td-actions .btn {
  transition: all 150ms ease-in;
}

.pull-center {
  float: none;
  margin: 0 auto;
}

.btn {
  transition: all 100ms ease-in;
}

.fa {
  width: 18px;
  text-align: center;
}

.margin-top {
  margin-top: 50px;
}

.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 260px;
  display: block;
  z-index: 1;
  color: #fff;
  font-weight: 200;
  background-size: cover;
  background-position: center center;
}
.sidebar .sidebar-wrapper {
  position: relative;
  height: calc(100vh - 75px);
  overflow: auto;
  width: 260px;
  z-index: 4;
  padding-bottom: 30px;
}
.sidebar .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .logo {
  padding: 10px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 4;
}
.sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #ffffff;
  line-height: 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.sidebar .logo a.logo-mini {
  float: left;
  text-align: center;
  width: 30px;
  margin-right: 15px;
}
.sidebar .logo a.logo-mini img {
  width: 40px;
  margin-left: -3px;
  display: block;
  margin-top: 2px;
}
.sidebar .logo a.logo-normal {
  display: block;
}
.sidebar .logo .logo-img {
  width: 34px;
  display: inline-block;
  height: 34px;
  margin-left: -2px;
  margin-top: -2px;
  margin-right: 10px;
  border-radius: 30px;
  text-align: center;
}
.sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav {
  margin-top: 20px;
}
.sidebar .nav li > a {
  color: #ffffff;
  margin: 5px 15px;
  opacity: 0.86;
  border-radius: 4px;
}
.sidebar .nav li:hover > a,
.sidebar .nav li.open > a,
.sidebar .nav li.open > a:focus,
.sidebar .nav li.open > a:hover {
  background: rgba(255, 255, 255, 0.13);
  opacity: 1;
}
.sidebar .nav li.active > a {
  color: #ffffff;
  opacity: 1;
  background: rgba(255, 255, 255, 0.23);
}
.sidebar .nav p {
  margin: 0;
  line-height: 30px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.sidebar .nav .caret {
  top: 24px;
  position: absolute;
  right: 15px;
}
.sidebar .nav i {
  font-size: 28px;
  float: left;
  margin-right: 15px;
  line-height: 30px;
  width: 30px;
  text-align: center;
}

.sidebar .logo,
body > .navbar-collapse .logo {
  padding: 10px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.sidebar .logo p,
body > .navbar-collapse .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #ffffff;
  line-height: 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.sidebar .logo .simple-text,
body > .navbar-collapse .logo .simple-text {
  text-transform: uppercase;
  padding: 5px 0px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  font-weight: 400;
  line-height: 30px;
}

.sidebar .logo-tim,
body > .navbar-collapse .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
body > .navbar-collapse .logo-tim img {
  width: 60px;
  height: 60px;
}

.sidebar:after,
.sidebar:before,
body > .navbar-collapse:after,
body > .navbar-collapse:before {
  display: block;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}

.sidebar:before,
body > .navbar-collapse:before {
  opacity: 0.33;
  background: #000000;
}

.sidebar:after,
body > .navbar-collapse:after {
  background: #282828;
  background: linear-gradient(to bottom, #282828 0%, #111 100%);
  background-size: 150% 150%;
  z-index: 3;
  opacity: 1;
}

.sidebar[data-image]:after,
.sidebar.has-image:after,
body > .navbar-collapse[data-image]:after,
body > .navbar-collapse.has-image:after {
  opacity: 0.77;
}

.sidebar[data-color='blue']:after,
body > .navbar-collapse[data-color='blue']:after {
  background: #1b8dff;
  background: linear-gradient(to bottom, #1b8dff 0%, #2632c1 100%);
  background-size: 150% 150%;
}

.sidebar[data-color='azure']:after,
body > .navbar-collapse[data-color='azure']:after {
  background: #1dc7ea;
  background: linear-gradient(to bottom, #1dc7ea 0%, #4091ff 100%);
  background-size: 150% 150%;
}

.sidebar[data-color='green']:after,
body > .navbar-collapse[data-color='green']:after {
  background: #87cb16;
  background: linear-gradient(to bottom, #87cb16 0%, #6dc030 100%);
  background-size: 150% 150%;
}

.sidebar[data-color='orange']:after,
body > .navbar-collapse[data-color='orange']:after {
  background: #ffa534;
  background: linear-gradient(to bottom, #ffa534 0%, #ff5221 100%);
  background-size: 150% 150%;
}

.sidebar[data-color='red']:after,
body > .navbar-collapse[data-color='red']:after {
  background: #fb404b;
  background: linear-gradient(to bottom, #fb404b 0%, #bb0502 100%);
  background-size: 150% 150%;
}

.sidebar[data-color='purple']:after,
body > .navbar-collapse[data-color='purple']:after {
  background: #9368e9;
  background: linear-gradient(to bottom, #9368e9 0%, #943bea 100%);
  background-size: 150% 150%;
}

.main-panel {
  background: rgba(203, 203, 210, 0.15);
  position: relative;
  float: right;
  width: calc(100% - 260px);
}
.main-panel > .content {
  padding: 30px 15px;
  min-height: calc(100% - 123px);
}
.main-panel > .footer {
  border-top: 1px solid #e7e7e7;
}
.main-panel .navbar {
  margin-bottom: 0;
}

.sidebar,
.main-panel {
  transition-property: top, bottom;
  transition-duration: 0.2s, 0.2s;
  transition-timing-function: linear, linear;
  -webkit-overflow-scrolling: touch;
}

.btn {
  border-width: 2px;
  background-color: transparent;
  font-weight: 400;
  opacity: 0.8;
  filter: alpha(opacity=80);
  padding: 8px 16px;
  border-color: #888888;
  color: #888888;
}
.btn:hover,
.btn:focus,
.btn:active,
.btn.active,
.open > .btn.dropdown-toggle {
  background-color: transparent;
  color: #777777;
  border-color: #777777;
}
.btn.disabled,
.btn.disabled:hover,
.btn.disabled:focus,
.btn.disabled.focus,
.btn.disabled:active,
.btn.disabled.active,
.btn:disabled,
.btn:disabled:hover,
.btn:disabled:focus,
.btn:disabled.focus,
.btn:disabled:active,
.btn:disabled.active,
.btn[disabled],
.btn[disabled]:hover,
.btn[disabled]:focus,
.btn[disabled].focus,
.btn[disabled]:active,
.btn[disabled].active,
fieldset[disabled] .btn,
fieldset[disabled] .btn:hover,
fieldset[disabled] .btn:focus,
fieldset[disabled] .btn.focus,
fieldset[disabled] .btn:active,
fieldset[disabled] .btn.active {
  background-color: transparent;
  border-color: #888888;
}
.btn.btn-fill {
  color: #ffffff;
  background-color: #888888;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn.btn-fill:hover,
.btn.btn-fill:focus,
.btn.btn-fill:active,
.btn.btn-fill.active,
.open > .btn.btn-fill.dropdown-toggle {
  background-color: #777777;
  color: #ffffff;
}
.btn.btn-fill .caret {
  border-top-color: #ffffff;
}
.btn .caret {
  border-top-color: #888888;
}
.btn:hover,
.btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.btn:active,
.btn.active,
.open > .btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn.btn-icon {
  padding: 8px;
}

.btn-primary {
  border-color: #3472f7;
  color: #3472f7;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.open > .btn-primary.dropdown-toggle {
  background-color: transparent;
  color: #1d62f0;
  border-color: #1d62f0;
}
.btn-primary.disabled,
.btn-primary.disabled:hover,
.btn-primary.disabled:focus,
.btn-primary.disabled.focus,
.btn-primary.disabled:active,
.btn-primary.disabled.active,
.btn-primary:disabled,
.btn-primary:disabled:hover,
.btn-primary:disabled:focus,
.btn-primary:disabled.focus,
.btn-primary:disabled:active,
.btn-primary:disabled.active,
.btn-primary[disabled],
.btn-primary[disabled]:hover,
.btn-primary[disabled]:focus,
.btn-primary[disabled].focus,
.btn-primary[disabled]:active,
.btn-primary[disabled].active,
fieldset[disabled] .btn-primary,
fieldset[disabled] .btn-primary:hover,
fieldset[disabled] .btn-primary:focus,
fieldset[disabled] .btn-primary.focus,
fieldset[disabled] .btn-primary:active,
fieldset[disabled] .btn-primary.active {
  background-color: transparent;
  border-color: #3472f7;
}
.btn-primary.btn-fill {
  color: #ffffff;
  background-color: #3472f7;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-primary.btn-fill:hover,
.btn-primary.btn-fill:focus,
.btn-primary.btn-fill:active,
.btn-primary.btn-fill.active,
.open > .btn-primary.btn-fill.dropdown-toggle {
  background-color: #1d62f0;
  color: #ffffff;
}
.btn-primary.btn-fill .caret {
  border-top-color: #ffffff;
}
.btn-primary .caret {
  border-top-color: #3472f7;
}

.btn-success {
  border-color: #87cb16;
  color: #87cb16;
}
.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.open > .btn-success.dropdown-toggle {
  background-color: transparent;
  color: #049f0c;
  border-color: #049f0c;
}
.btn-success.disabled,
.btn-success.disabled:hover,
.btn-success.disabled:focus,
.btn-success.disabled.focus,
.btn-success.disabled:active,
.btn-success.disabled.active,
.btn-success:disabled,
.btn-success:disabled:hover,
.btn-success:disabled:focus,
.btn-success:disabled.focus,
.btn-success:disabled:active,
.btn-success:disabled.active,
.btn-success[disabled],
.btn-success[disabled]:hover,
.btn-success[disabled]:focus,
.btn-success[disabled].focus,
.btn-success[disabled]:active,
.btn-success[disabled].active,
fieldset[disabled] .btn-success,
fieldset[disabled] .btn-success:hover,
fieldset[disabled] .btn-success:focus,
fieldset[disabled] .btn-success.focus,
fieldset[disabled] .btn-success:active,
fieldset[disabled] .btn-success.active {
  background-color: transparent;
  border-color: #87cb16;
}
.btn-success.btn-fill {
  color: #ffffff;
  background-color: #87cb16;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-success.btn-fill:hover,
.btn-success.btn-fill:focus,
.btn-success.btn-fill:active,
.btn-success.btn-fill.active,
.open > .btn-success.btn-fill.dropdown-toggle {
  background-color: #049f0c;
  color: #ffffff;
}
.btn-success.btn-fill .caret {
  border-top-color: #ffffff;
}
.btn-success .caret {
  border-top-color: #87cb16;
}

.btn-info {
  border-color: #1dc7ea;
  color: #1dc7ea;
}
.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.open > .btn-info.dropdown-toggle {
  background-color: transparent;
  color: #42d0ed;
  border-color: #42d0ed;
}
.btn-info.disabled,
.btn-info.disabled:hover,
.btn-info.disabled:focus,
.btn-info.disabled.focus,
.btn-info.disabled:active,
.btn-info.disabled.active,
.btn-info:disabled,
.btn-info:disabled:hover,
.btn-info:disabled:focus,
.btn-info:disabled.focus,
.btn-info:disabled:active,
.btn-info:disabled.active,
.btn-info[disabled],
.btn-info[disabled]:hover,
.btn-info[disabled]:focus,
.btn-info[disabled].focus,
.btn-info[disabled]:active,
.btn-info[disabled].active,
fieldset[disabled] .btn-info,
fieldset[disabled] .btn-info:hover,
fieldset[disabled] .btn-info:focus,
fieldset[disabled] .btn-info.focus,
fieldset[disabled] .btn-info:active,
fieldset[disabled] .btn-info.active {
  background-color: transparent;
  border-color: #1dc7ea;
}
.btn-info.btn-fill {
  color: #ffffff;
  background-color: #1dc7ea;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-info.btn-fill:hover,
.btn-info.btn-fill:focus,
.btn-info.btn-fill:active,
.btn-info.btn-fill.active,
.open > .btn-info.btn-fill.dropdown-toggle {
  background-color: #42d0ed;
  color: #ffffff;
}
.btn-info.btn-fill .caret {
  border-top-color: #ffffff;
}
.btn-info .caret {
  border-top-color: #1dc7ea;
}

.btn-warning {
  border-color: #ff9500;
  color: #ff9500;
}
.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.open > .btn-warning.dropdown-toggle {
  background-color: transparent;
  color: #ed8d00;
  border-color: #ed8d00;
}
.btn-warning.disabled,
.btn-warning.disabled:hover,
.btn-warning.disabled:focus,
.btn-warning.disabled.focus,
.btn-warning.disabled:active,
.btn-warning.disabled.active,
.btn-warning:disabled,
.btn-warning:disabled:hover,
.btn-warning:disabled:focus,
.btn-warning:disabled.focus,
.btn-warning:disabled:active,
.btn-warning:disabled.active,
.btn-warning[disabled],
.btn-warning[disabled]:hover,
.btn-warning[disabled]:focus,
.btn-warning[disabled].focus,
.btn-warning[disabled]:active,
.btn-warning[disabled].active,
fieldset[disabled] .btn-warning,
fieldset[disabled] .btn-warning:hover,
fieldset[disabled] .btn-warning:focus,
fieldset[disabled] .btn-warning.focus,
fieldset[disabled] .btn-warning:active,
fieldset[disabled] .btn-warning.active {
  background-color: transparent;
  border-color: #ff9500;
}
.btn-warning.btn-fill {
  color: #ffffff;
  background-color: #ff9500;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-warning.btn-fill:hover,
.btn-warning.btn-fill:focus,
.btn-warning.btn-fill:active,
.btn-warning.btn-fill.active,
.open > .btn-warning.btn-fill.dropdown-toggle {
  background-color: #ed8d00;
  color: #ffffff;
}
.btn-warning.btn-fill .caret {
  border-top-color: #ffffff;
}
.btn-warning .caret {
  border-top-color: #ff9500;
}

.btn-danger {
  border-color: #ff4a55;
  color: #ff4a55;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active,
.open > .btn-danger.dropdown-toggle {
  background-color: transparent;
  color: #ee2d20;
  border-color: #ee2d20;
}
.btn-danger.disabled,
.btn-danger.disabled:hover,
.btn-danger.disabled:focus,
.btn-danger.disabled.focus,
.btn-danger.disabled:active,
.btn-danger.disabled.active,
.btn-danger:disabled,
.btn-danger:disabled:hover,
.btn-danger:disabled:focus,
.btn-danger:disabled.focus,
.btn-danger:disabled:active,
.btn-danger:disabled.active,
.btn-danger[disabled],
.btn-danger[disabled]:hover,
.btn-danger[disabled]:focus,
.btn-danger[disabled].focus,
.btn-danger[disabled]:active,
.btn-danger[disabled].active,
fieldset[disabled] .btn-danger,
fieldset[disabled] .btn-danger:hover,
fieldset[disabled] .btn-danger:focus,
fieldset[disabled] .btn-danger.focus,
fieldset[disabled] .btn-danger:active,
fieldset[disabled] .btn-danger.active {
  background-color: transparent;
  border-color: #ff4a55;
}
.btn-danger.btn-fill {
  color: #ffffff;
  background-color: #ff4a55;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-danger.btn-fill:hover,
.btn-danger.btn-fill:focus,
.btn-danger.btn-fill:active,
.btn-danger.btn-fill.active,
.open > .btn-danger.btn-fill.dropdown-toggle {
  background-color: #ee2d20;
  color: #ffffff;
}
.btn-danger.btn-fill .caret {
  border-top-color: #ffffff;
}
.btn-danger .caret {
  border-top-color: #ff4a55;
}

.btn-neutral {
  border-color: #ffffff;
  color: #ffffff;
}
.btn-neutral:hover,
.btn-neutral:focus,
.btn-neutral:active,
.btn-neutral.active,
.open > .btn-neutral.dropdown-toggle {
  background-color: transparent;
  color: #ffffff;
  border-color: #ffffff;
}
.btn-neutral.disabled,
.btn-neutral.disabled:hover,
.btn-neutral.disabled:focus,
.btn-neutral.disabled.focus,
.btn-neutral.disabled:active,
.btn-neutral.disabled.active,
.btn-neutral:disabled,
.btn-neutral:disabled:hover,
.btn-neutral:disabled:focus,
.btn-neutral:disabled.focus,
.btn-neutral:disabled:active,
.btn-neutral:disabled.active,
.btn-neutral[disabled],
.btn-neutral[disabled]:hover,
.btn-neutral[disabled]:focus,
.btn-neutral[disabled].focus,
.btn-neutral[disabled]:active,
.btn-neutral[disabled].active,
fieldset[disabled] .btn-neutral,
fieldset[disabled] .btn-neutral:hover,
fieldset[disabled] .btn-neutral:focus,
fieldset[disabled] .btn-neutral.focus,
fieldset[disabled] .btn-neutral:active,
fieldset[disabled] .btn-neutral.active {
  background-color: transparent;
  border-color: #ffffff;
}
.btn-neutral.btn-fill {
  color: #ffffff;
  background-color: #ffffff;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-neutral.btn-fill:hover,
.btn-neutral.btn-fill:focus,
.btn-neutral.btn-fill:active,
.btn-neutral.btn-fill.active,
.open > .btn-neutral.btn-fill.dropdown-toggle {
  background-color: #ffffff;
  color: #ffffff;
}
.btn-neutral.btn-fill .caret {
  border-top-color: #ffffff;
}
.btn-neutral .caret {
  border-top-color: #ffffff;
}
.btn-neutral:active,
.btn-neutral.active,
.open > .btn-neutral.dropdown-toggle {
  background-color: #ffffff;
  color: #888888;
}
.btn-neutral.btn-fill,
.btn-neutral.btn-fill:hover,
.btn-neutral.btn-fill:focus {
  color: #888888;
}
.btn-neutral.btn-simple:active,
.btn-neutral.btn-simple.active {
  background-color: transparent;
}

.btn:disabled,
.btn[disabled],
.btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
}

.btn-round {
  border-width: 1px;
  border-radius: 30px !important;
  padding: 9px 18px;
}
.btn-round.btn-icon {
  padding: 9px;
}

.btn-simple {
  border: 0;
  font-size: 16px;
  padding: 8px 16px;
}
.btn-simple.btn-icon {
  padding: 8px;
}

.btn-lg {
  font-size: 18px;
  border-radius: 6px;
  padding: 14px 30px;
  font-weight: 400;
}
.btn-lg.btn-round {
  padding: 15px 30px;
}
.btn-lg.btn-simple {
  padding: 16px 30px;
}

.btn-sm {
  font-size: 12px;
  border-radius: 3px;
  padding: 5px 10px;
}
.btn-sm.btn-round {
  padding: 6px 10px;
}
.btn-sm.btn-simple {
  padding: 7px 10px;
}

.btn-xs {
  font-size: 12px;
  border-radius: 3px;
  padding: 1px 5px;
}
.btn-xs.btn-round {
  padding: 2px 5px;
}
.btn-xs.btn-simple {
  padding: 3px 5px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.form-control::-moz-placeholder {
  color: #dddddd;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-moz-placeholder {
  color: #dddddd;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control::-webkit-input-placeholder {
  color: #dddddd;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-ms-input-placeholder {
  color: #dddddd;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control {
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  color: #565656;
  padding: 8px 12px;
  height: 40px;
  box-shadow: none;
}
.form-control:focus {
  background-color: #ffffff;
  border: 1px solid #aaaaaa;
  box-shadow: none;
  outline: 0 !important;
  color: #333333;
}
.has-success .form-control,
.has-error .form-control,
.has-success .form-control:focus,
.has-error .form-control:focus {
  border-color: #e3e3e3;
  box-shadow: none;
}
.has-success .form-control {
  color: #87cb16;
}
.has-success .form-control:focus {
  border-color: #87cb16;
}
.has-error .form-control {
  color: #ff4a55;
}
.has-error .form-control:focus {
  border-color: #ff4a55;
}
.form-control + .form-control-feedback {
  border-radius: 6px;
  font-size: 14px;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 4px 4px 0 0;
  border-bottom-color: transparent;
}

.input-lg {
  height: 55px;
  padding: 14px 30px;
}

.has-error .form-control-feedback {
  color: #ff4a55;
}

.has-success .form-control-feedback {
  color: #87cb16;
}

.input-group-addon {
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
}
.has-success .input-group-addon,
.has-error .input-group-addon {
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
}
.has-error .form-control:focus + .input-group-addon {
  border-color: #ff4a55;
  color: #ff4a55;
}
.has-success .form-control:focus + .input-group-addon {
  border-color: #87cb16;
  color: #87cb16;
}
.form-control:focus + .input-group-addon,
.form-control:focus ~ .input-group-addon {
  background-color: #ffffff;
  border-color: #9a9a9a;
}

.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  background-color: #f5f5f5;
  color: #888888;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 9px 16px;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #dddddd;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

.input-group-focus .input-group-addon {
  border-color: #9a9a9a;
}

.alert {
  border: 0;
  border-radius: 0;
  color: #ffffff;
  padding: 10px 15px;
  font-size: 14px;
}
.container .alert {
  border-radius: 4px;
}
.navbar .alert {
  border-radius: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 85px;
  width: 100%;
  z-index: 3;
}
.navbar:not(.navbar-transparent) .alert {
  top: 70px;
}
.alert span[data-notify='icon'] {
  font-size: 30px;
  display: block;
  left: 15px;
  position: absolute;
  top: 50%;
  margin-top: -15px;
}
.alert button.close {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -13px;
  z-index: 1033;
  background-color: #ffffff;
  display: block;
  border-radius: 50%;
  opacity: 0.4;
  line-height: 20px;
  font-size: 12px;
  width: 25px;
  height: 25px;
  outline: 0 !important;
  text-align: center;
  padding: 3px;
  font-weight: 300;
}
.alert button.close:hover {
  opacity: 0.55;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert[data-notify='container'] {
  padding: 10px 10px 10px 20px;
  border-radius: 4px;
}
.alert.alert-with-icon {
  padding-left: 65px;
}
.alert a,
.alert a:hover,
.alert a:focus {
  text-decoration: underline;
  color: white;
}

.alert-info {
  background-color: #63d8f1;
}

.alert-success {
  background-color: #a1e82c;
}

.alert-warning {
  background-color: #ffbc67;
}

.alert-danger {
  background-color: #fc727a;
}

.table .radio,
.table .checkbox {
  position: relative;
  height: 20px;
  display: block;
  width: 20px;
  padding: 0px 0px;
  margin: 0px 5px;
  text-align: center;
}
.table .radio .icons,
.table .checkbox .icons {
  left: 5px;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 12px 8px;
  vertical-align: middle;
}

.table > tbody > tr > td {
  font-size: 14px;
}

.table > thead > tr > th {
  border-bottom-width: 1px;
  font-size: 12px;
  text-transform: uppercase;
  color: #9a9a9a;
  font-weight: 400;
  padding-bottom: 5px;
}

.table .td-actions .btn {
  opacity: 0.36;
  filter: alpha(opacity=36);
}
.table .td-actions .btn.btn-xs {
  padding-left: 3px;
  padding-right: 3px;
}

.table .td-actions {
  min-width: 90px;
}

.table > tbody > tr {
  position: relative;
}
.table > tbody > tr:hover .td-actions .btn {
  opacity: 1;
  filter: alpha(opacity=100);
}

/*      Checkbox and radio         */
.checkbox,
.radio {
  margin-bottom: 12px;
}

.checkbox label,
.radio label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 24px;
  margin-bottom: 0;
}

.checkbox label::before,
.checkbox label::after {
  font-family: 'FontAwesome';
  content: '\\f096';
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  left: 0;
  cursor: pointer;
  line-height: 19px;
  font-size: 20px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  top: 1px;
  color: #dddddd;
  transition: color 0.2s linear;
  padding: 1px;
}

.checkbox label::after {
  content: '';
  text-align: center;
  opacity: 1;
  left: 1px;
  color: #dddddd;
}

.checkbox input[type='checkbox'],
.radio input[type='radio'] {
  opacity: 0;
  margin-left: 0;
}

.checkbox input[type='checkbox']:checked + label::after {
  font-family: 'FontAwesome';
  content: '\\f046';
}

.checkbox input[type='checkbox']:checked + label::after {
  color: #1dc7ea;
}

.checkbox input[type='checkbox']:checked + label::before {
  opacity: 0;
}

.checkbox input[type='checkbox']:disabled + label,
.radio input[type='radio']:disabled + label,
.checkbox input[type='checkbox']:disabled:checked + label::after {
  color: #dddddd;
}

.checkbox input[type='checkbox']:disabled + label::before,
.checkbox input[type='checkbox']:disabled + label::after {
  cursor: not-allowed;
}

.checkbox input[type='checkbox']:disabled + label,
.radio input[type='radio']:disabled + label {
  cursor: not-allowed;
}

.checkbox.checkbox-circle label::before {
  border-radius: 50%;
}

.checkbox.checkbox-inline {
  padding-left: 0;
}

.checkbox-primary input[type='checkbox']:checked + label::before {
  background-color: #428bca;
  border-color: #428bca;
}

.checkbox-primary input[type='checkbox']:checked + label::after {
  color: #fff;
}

.checkbox-danger input[type='checkbox']:checked + label::before {
  background-color: #d9534f;
  border-color: #d9534f;
}

.checkbox-danger input[type='checkbox']:checked + label::after {
  color: #fff;
}

.checkbox-info input[type='checkbox']:checked + label::before {
  background-color: #5bc0de;
  border-color: #5bc0de;
}

.checkbox-info input[type='checkbox']:checked + label::after {
  color: #fff;
}

.checkbox-warning input[type='checkbox']:checked + label::before {
  background-color: #f0ad4e;
  border-color: #f0ad4e;
}

.checkbox-warning input[type='checkbox']:checked + label::after {
  color: #fff;
}

.checkbox-success input[type='checkbox']:checked + label::before {
  background-color: #5cb85c;
  border-color: #5cb85c;
}

.checkbox-success input[type='checkbox']:checked + label::after {
  color: #fff;
}

.radio label::before,
.radio label::after {
  font-family: 'FontAwesome';
  content: '\\f10c';
  font-size: 20px;
  height: 20px;
  width: 20px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  position: absolute;
  line-height: 19px;
  left: 0;
  top: 0;
  color: #dddddd;
  padding: 1px;
  transition: color 0.2s linear;
}

.radio input[type='radio']:checked + label::after {
  font-family: 'FontAwesome';
  content: '\\f192';
  color: #dddddd;
}

.radio input[type='radio']:checked + label::after {
  color: #1dc7ea;
}

.radio input[type='radio']:disabled + label {
  color: #ddd;
}

.radio input[type='radio']:disabled + label::before,
.radio input[type='radio']:disabled + label::after {
  color: #ddd;
}

.radio.radio-inline {
  margin-top: 0;
}

/**
  * bootstrap-switch - Turn checkboxes and radio buttons into toggle switches.
  *
  * @version v3.3.4
  * @homepage https://bttstrp.github.io/bootstrap-switch
  * @author Mattia Larentis <mattia@larentis.eu> (http://larentis.eu)
  * @license Apache-2.0
  */
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid;
  border-color: #ccc;
  position: relative;
  text-align: left;
  overflow: hidden;
  line-height: 8px;
  z-index: 0;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-block;
  top: 0;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: table-cell;
  vertical-align: middle;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 20px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {
  color: #fff;
  background: #337ab7;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {
  color: #fff;
  background: #5bc0de;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {
  color: #fff;
  background: #5cb85c;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {
  background: #f0ad4e;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {
  color: #fff;
  background: #d9534f;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #000;
  background: #eeeeee;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  margin-top: -1px;
  margin-bottom: -1px;
  z-index: 100;
  color: #333;
  background: #fff;
}

.bootstrap-switch span::before {
  content: '\\200b';
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch input[type='radio'],
.bootstrap-switch input[type='checkbox'] {
  position: absolute !important;
  top: 0;
  left: 0;
  margin: 0;
  z-index: -1;
  opacity: 0;
  filter: alpha(opacity=0);
  visibility: hidden;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.3333333;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-focused {
  border-color: #66afe9;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-off
  .bootstrap-switch-label {
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-on
  .bootstrap-switch-label {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.nav > li > a:hover,
.nav > li > a:focus {
  background-color: transparent;
}

.navbar {
  border: 0;
  font-size: 16px;
  border-radius: 0;
}
.navbar .navbar-brand {
  font-weight: 400;
  margin: 5px 0px;
  padding: 15px 15px;
  font-size: 20px;
}
.navbar .navbar-nav > li > a {
  padding: 10px 15px;
  margin: 10px 3px;
  position: relative;
}
.navbar .navbar-nav > li > a.btn {
  margin: 15px 3px;
  padding: 8px 16px;
}
.navbar .navbar-nav > li > a.btn-round {
  margin: 16px 3px;
}
.navbar .navbar-nav > li > a [class^='fa'] {
  font-size: 19px;
  position: relative;
  line-height: 16px;
  top: 1px;
}
.navbar .navbar-nav .notification {
  position: absolute;
  background-color: #fb404b;
  text-align: center;
  border-radius: 10px;
  min-width: 18px;
  padding: 0 5px;
  height: 18px;
  font-size: 12px;
  color: #ffffff;
  font-weight: bold;
  line-height: 18px;
  top: 0px;
  left: 7px;
}
.navbar .btn {
  margin: 15px 3px;
  font-size: 14px;
}
.navbar .btn-simple {
  font-size: 16px;
}
.navbar.fixed {
  width: calc(100%);
  right: 0;
  left: auto;
  border-radius: 0;
}

.navbar-nav > li > .dropdown-menu {
  border-radius: 10px;
  margin-top: -5px;
}

.navbar-transparent .navbar-brand,
[class*='navbar-ct'] .navbar-brand {
  color: #ffffff;
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.navbar-transparent .navbar-brand:focus,
.navbar-transparent .navbar-brand:hover,
[class*='navbar-ct'] .navbar-brand:focus,
[class*='navbar-ct'] .navbar-brand:hover {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-transparent .navbar-nav > li > a:not(.btn),
[class*='navbar-ct'] .navbar-nav > li > a:not(.btn) {
  color: #ffffff;
  border-color: #ffffff;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.navbar-transparent .navbar-nav > .active > a:not(.btn),
.navbar-transparent .navbar-nav > .active > a:hover:not(.btn),
.navbar-transparent .navbar-nav > .active > a:focus:not(.btn),
.navbar-transparent .navbar-nav > li > a:hover:not(.btn),
.navbar-transparent .navbar-nav > li > a:focus:not(.btn),
[class*='navbar-ct'] .navbar-nav > .active > a:not(.btn),
[class*='navbar-ct'] .navbar-nav > .active > a:hover:not(.btn),
[class*='navbar-ct'] .navbar-nav > .active > a:focus:not(.btn),
[class*='navbar-ct'] .navbar-nav > li > a:hover:not(.btn),
[class*='navbar-ct'] .navbar-nav > li > a:focus:not(.btn) {
  background-color: transparent;
  border-radius: 3px;
  color: #ffffff;
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-transparent .navbar-nav .nav > li > a.btn:hover,
[class*='navbar-ct'] .navbar-nav .nav > li > a.btn:hover {
  background-color: transparent;
}

.navbar-transparent .navbar-nav > .dropdown > a .caret,
.navbar-transparent .navbar-nav > .dropdown > a:hover .caret,
.navbar-transparent .navbar-nav > .dropdown > a:focus .caret,
[class*='navbar-ct'] .navbar-nav > .dropdown > a .caret,
[class*='navbar-ct'] .navbar-nav > .dropdown > a:hover .caret,
[class*='navbar-ct'] .navbar-nav > .dropdown > a:focus .caret {
  border-bottom-color: #ffffff;
  border-top-color: #ffffff;
}

.navbar-transparent .navbar-nav > .open > a,
.navbar-transparent .navbar-nav > .open > a:hover,
.navbar-transparent .navbar-nav > .open > a:focus,
[class*='navbar-ct'] .navbar-nav > .open > a,
[class*='navbar-ct'] .navbar-nav > .open > a:hover,
[class*='navbar-ct'] .navbar-nav > .open > a:focus {
  background-color: transparent;
  color: #ffffff;
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-transparent .btn-default,
[class*='navbar-ct'] .btn-default {
  color: #ffffff;
  border-color: #ffffff;
}

.navbar-transparent .btn-default.btn-fill,
[class*='navbar-ct'] .btn-default.btn-fill {
  color: #9a9a9a;
  background-color: #ffffff;
  opacity: 0.9;
  filter: alpha(opacity=90);
}

.navbar-transparent .btn-default.btn-fill:hover,
.navbar-transparent .btn-default.btn-fill:focus,
.navbar-transparent .btn-default.btn-fill:active,
.navbar-transparent .btn-default.btn-fill.active,
.navbar-transparent .open .dropdown-toggle.btn-fill.btn-default,
[class*='navbar-ct'] .btn-default.btn-fill:hover,
[class*='navbar-ct'] .btn-default.btn-fill:focus,
[class*='navbar-ct'] .btn-default.btn-fill:active,
[class*='navbar-ct'] .btn-default.btn-fill.active,
[class*='navbar-ct'] .open .dropdown-toggle.btn-fill.btn-default {
  border-color: #ffffff;
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-transparent .dropdown-menu .divider {
  background-color: rgba(255, 255, 255, 0.2);
}

.nav-open .nav .caret {
  border-bottom-color: #ffffff;
  border-top-color: #ffffff;
}

.navbar-default {
  background-color: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.navbar-default .navbar-nav > li > a:not(.btn) {
  color: #9a9a9a;
}
.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:not(.btn):hover,
.navbar-default .navbar-nav > .active > a:not(.btn):focus,
.navbar-default .navbar-nav > li > a:not(.btn):hover,
.navbar-default .navbar-nav > li > a:not(.btn):focus {
  background-color: transparent;
  border-radius: 3px;
  color: #1dc7ea;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-default .navbar-nav > .dropdown > a:hover .caret,
.navbar-default .navbar-nav > .dropdown > a:focus .caret {
  border-bottom-color: #1dc7ea;
  border-top-color: #1dc7ea;
}
.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus {
  background-color: transparent;
  color: #1dc7ea;
}
.navbar-default .navbar-nav .navbar-toggle:hover,
.navbar-default .navbar-nav .navbar-toggle:focus {
  background-color: transparent;
}
.navbar-default:not(.navbar-transparent) .btn-default:hover {
  color: #1dc7ea;
  border-color: #1dc7ea;
}
.navbar-default:not(.navbar-transparent) .btn-neutral,
.navbar-default:not(.navbar-transparent) .btn-neutral:hover,
.navbar-default:not(.navbar-transparent) .btn-neutral:active {
  color: #9a9a9a;
}

/*      Navbar with icons            */
.navbar-icons.navbar .navbar-brand {
  margin-top: 12px;
  margin-bottom: 12px;
}

.navbar-icons .navbar-nav > li > a {
  text-align: center;
  padding: 6px 15px;
  margin: 6px 3px;
}

.navbar-icons .navbar-nav [class^='pe'] {
  font-size: 30px;
  position: relative;
}

.navbar-icons .navbar-nav p {
  margin: 3px 0 0;
}

.navbar-form {
  box-shadow: none;
}
.navbar-form .form-control {
  border-radius: 0;
  border: 0;
  padding: 0;
  background-color: transparent;
  height: 22px;
  font-size: 16px;
  line-height: 1.5;
  color: #e3e3e3;
}
.navbar-transparent .navbar-form .form-control,
[class*='navbar-ct'] .navbar-form .form-control {
  color: #ffffff;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
}

.navbar-ct-blue {
  background-color: #4ea7ff;
}

.navbar-ct-azure {
  background-color: #63d8f1;
}

.navbar-ct-green {
  background-color: #a1e82c;
}

.navbar-ct-orange {
  background-color: #ffbc67;
}

.navbar-ct-red {
  background-color: #fc727a;
}

.navbar-transparent {
  padding-top: 15px;
  background-color: transparent;
  border-bottom: 1px solid transparent;
}

.navbar-toggle {
  margin-top: 19px;
  margin-bottom: 19px;
  border: 0;
}
.navbar-toggle .icon-bar {
  background-color: #ffffff;
}
.navbar-toggle .navbar-collapse,
.navbar-toggle .navbar-form {
  border-color: transparent;
}
.navbar-toggle.navbar-default .navbar-toggle:hover,
.navbar-toggle.navbar-default .navbar-toggle:focus {
  background-color: transparent;
}

.footer {
  background-color: #ffffff;
  line-height: 20px;
}
.footer nav > ul {
  list-style: none;
  margin: 0;
  padding: 0;
  font-weight: normal;
}
.footer nav > ul a:not(.btn) {
  color: #9a9a9a;
  display: block;
  margin-bottom: 3px;
}
.footer nav > ul a:not(.btn):hover,
.footer nav > ul a:not(.btn):focus {
  color: #777777;
}
.footer .social-area {
  padding: 15px 0;
}
.footer .social-area h5 {
  padding-bottom: 15px;
}
.footer .social-area > a:not(.btn) {
  color: #9a9a9a;
  display: inline-block;
  vertical-align: top;
  padding: 10px 5px;
  font-size: 20px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
}
.footer .social-area > a:not(.btn):hover,
.footer .social-area > a:not(.btn):focus {
  color: #777777;
}
.footer .copyright {
  color: #777777;
  padding: 10px 15px;
  margin: 10px 3px;
  line-height: 20px;
  font-size: 14px;
}
.footer hr {
  border-color: #dddddd;
}
.footer .title {
  color: #777777;
}

.footer-default {
  background-color: #f5f5f5;
}

.footer:not(.footer-big) nav > ul {
  font-size: 14px;
}
.footer:not(.footer-big) nav > ul li {
  margin-left: 20px;
  float: left;
}
.footer:not(.footer-big) nav > ul a {
  padding: 10px 0px;
  margin: 10px 10px 10px 0px;
}

.dropdown-menu {
  visibility: hidden;
  margin: 0;
  padding: 0;
  border-radius: 10px;
  display: block;
  z-index: 9000;
  position: absolute;
  opacity: 0;
  filter: alpha(opacity=0);
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);
}
.open .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
}
.select .dropdown-menu {
  border-radius: 0 0 10px 10px;
  box-shadow: none;
  transform-origin: 50% -40px;
  transform: scale(1);
  transition: all 150ms linear;
  margin-top: -20px;
}
.select.open .dropdown-menu {
  margin-top: -1px;
}
.dropdown-menu > li > a {
  padding: 8px 16px;
  color: #333333;
}
.dropdown-menu > li > a img {
  margin-top: -3px;
}
.dropdown-menu > li > a:focus {
  outline: 0 !important;
}
.btn-group.select .dropdown-menu {
  min-width: 100%;
}
.dropdown-menu > li:first-child > a {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.dropdown-menu > li:last-child > a {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.select .dropdown-menu > li:first-child > a {
  border-radius: 0;
  border-bottom: 0 none;
}
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-color: #f5f5f5;
  color: #333333;
  opacity: 1;
  text-decoration: none;
}
.dropdown-menu.dropdown-blue > li > a:hover,
.dropdown-menu.dropdown-blue > li > a:focus {
  background-color: rgba(52, 114, 247, 0.2);
}
.dropdown-menu.dropdown-azure > li > a:hover,
.dropdown-menu.dropdown-azure > li > a:focus {
  background-color: rgba(29, 199, 234, 0.2);
}
.dropdown-menu.ct-green > li > a:hover,
.dropdown-menu.ct-green > li > a:focus {
  background-color: rgba(135, 203, 22, 0.2);
}
.dropdown-menu.dropdown-orange > li > a:hover,
.dropdown-menu.dropdown-orange > li > a:focus {
  background-color: rgba(255, 149, 0, 0.2);
}
.dropdown-menu.dropdown-red > li > a:hover,
.dropdown-menu.dropdown-red > li > a:focus {
  background-color: rgba(255, 74, 85, 0.2);
}

.dropdown-with-icons > li > a {
  padding-left: 0px;
  line-height: 28px;
}

.dropdown-with-icons i {
  text-align: center;
  line-height: 28px;
  float: left;
}
.dropdown-with-icons i[class^='pe-'] {
  font-size: 24px;
  width: 46px;
}
.dropdown-with-icons i[class^='fa'] {
  font-size: 14px;
  width: 38px;
}

.btn-group.select {
  overflow: hidden;
}

.btn-group.select.open {
  overflow: visible;
}

.card {
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(63, 63, 68, 0.1);
  background-color: #ffffff;
  margin-bottom: 30px;
}
.card .image {
  width: 100%;
  overflow: hidden;
  height: 260px;
  border-radius: 4px 4px 0 0;
  position: relative;
  transform-style: preserve-3d;
}
.card .image img {
  width: 100%;
}
.card .filter {
  position: absolute;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.68);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  opacity: 0;
  filter: alpha(opacity=0);
}
.card .filter .btn {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.card:hover .filter {
  opacity: 1;
  filter: alpha(opacity=100);
}
.card .btn-hover {
  opacity: 0;
  filter: alpha(opacity=0);
}
.card:hover .btn-hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
.card .content {
  padding: 15px 15px 10px 15px;
}
.card .header {
  padding: 15px 15px 0;
}
.card .category,
.card label {
  font-size: 14px;
  font-weight: 400;
  color: #9a9a9a;
  margin-bottom: 0px;
}
.card .category i,
.card label i {
  font-size: 16px;
}
.card label {
  font-size: 12px;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.card .title {
  margin: 0;
  color: #333333;
  font-weight: 300;
}
.card .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}
.card .description {
  font-size: 14px;
  color: #333;
}
.card .footer {
  padding: 0;
  background-color: transparent;
  line-height: 30px;
}
.card .footer .legend {
  padding: 5px 0;
}
.card .footer hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
.card .stats {
  color: #a9a9a9;
}
.card .footer div {
  display: inline-block;
}
.card .author {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.card .author i {
  font-size: 14px;
}
.card h6 {
  font-size: 12px;
  margin: 0;
}
.card.card-separator:after {
  height: 100%;
  right: -15px;
  top: 0;
  width: 1px;
  background-color: #dddddd;
  content: '';
  position: absolute;
}
.card .ct-chart {
  margin: 30px 0 30px;
  height: 245px;
}
.card .table tbody td:first-child,
.card .table thead th:first-child {
  padding-left: 15px;
}
.card .table tbody td:last-child,
.card .table thead th:last-child {
  padding-right: 15px;
}
.card .alert {
  border-radius: 4px;
  position: relative;
}
.card .alert.alert-with-icon {
  padding-left: 65px;
}

.card-user .image {
  height: 110px;
}

.card-user .image-plain {
  height: 0;
  margin-top: 110px;
}

.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: -70px;
}

.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 5px solid #ffffff;
  position: relative;
  margin-bottom: 15px;
}
.card-user .avatar.border-gray {
  border-color: #eeeeee;
}

.card-user .title {
  line-height: 24px;
}

.card-user .content {
  min-height: 240px;
}

.card-user .footer,
.card-price .footer {
  padding: 5px 15px 10px;
}

.card-user hr,
.card-price hr {
  margin: 5px 15px;
}

.card-plain {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
}
.card-plain .image {
  border-radius: 4px;
}

.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px;
}
.card-stats .icon-big i {
  font-weight: bold;
  line-height: 59px;
}

.card-stats .numbers {
  font-size: 2em;
  text-align: right;
}
.card-stats .numbers p {
  margin: 0;
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  color: rgba(0, 0, 0, 0.4);
  font-size: 1.3rem;
  line-height: 1;
}

.ct-chart-line .ct-label,
.ct-chart-bar .ct-label {
  display: block;
  display: flex;
}

.ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-vertical.ct-start {
  align-items: flex-end;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-label.ct-vertical.ct-end {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  text-anchor: end;
}

.ct-grid {
  stroke: rgba(0, 0, 0, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px;
}

.ct-point {
  stroke-width: 8px;
  stroke-linecap: round;
}

.ct-line {
  fill: none;
  stroke-width: 3px;
}

.ct-area {
  stroke: none;
  fill-opacity: 0.8;
}

.ct-bar {
  fill: none;
  stroke-width: 10px;
}

.ct-slice-donut {
  fill: none;
  stroke-width: 60px;
}

.ct-series-a .ct-point,
.ct-series-a .ct-line,
.ct-series-a .ct-bar,
.ct-series-a .ct-slice-donut {
  stroke: #1dc7ea;
}

.ct-series-a .ct-slice-pie,
.ct-series-a .ct-area {
  fill: #1dc7ea;
}

.ct-series-b .ct-point,
.ct-series-b .ct-line,
.ct-series-b .ct-bar,
.ct-series-b .ct-slice-donut {
  stroke: #fb404b;
}

.ct-series-b .ct-slice-pie,
.ct-series-b .ct-area {
  fill: #fb404b;
}

.ct-series-c .ct-point,
.ct-series-c .ct-line,
.ct-series-c .ct-bar,
.ct-series-c .ct-slice-donut {
  stroke: #ffa534;
}

.ct-series-c .ct-slice-pie,
.ct-series-c .ct-area {
  fill: #ffa534;
}

.ct-series-d .ct-point,
.ct-series-d .ct-line,
.ct-series-d .ct-bar,
.ct-series-d .ct-slice-donut {
  stroke: #9368e9;
}

.ct-series-d .ct-slice-pie,
.ct-series-d .ct-area {
  fill: #9368e9;
}

.ct-series-e .ct-point,
.ct-series-e .ct-line,
.ct-series-e .ct-bar,
.ct-series-e .ct-slice-donut {
  stroke: #87cb16;
}

.ct-series-e .ct-slice-pie,
.ct-series-e .ct-area {
  fill: #87cb16;
}

.ct-series-f .ct-point,
.ct-series-f .ct-line,
.ct-series-f .ct-bar,
.ct-series-f .ct-slice-donut {
  stroke: #1b8dff;
}

.ct-series-f .ct-slice-pie,
.ct-series-f .ct-area {
  fill: #1b8dff;
}

.ct-series-g .ct-point,
.ct-series-g .ct-line,
.ct-series-g .ct-bar,
.ct-series-g .ct-slice-donut {
  stroke: #5e5e5e;
}

.ct-series-g .ct-slice-pie,
.ct-series-g .ct-area {
  fill: #5e5e5e;
}

.ct-series-h .ct-point,
.ct-series-h .ct-line,
.ct-series-h .ct-bar,
.ct-series-h .ct-slice-donut {
  stroke: #dd4b39;
}

.ct-series-h .ct-slice-pie,
.ct-series-h .ct-area {
  fill: #dd4b39;
}

.ct-series-i .ct-point,
.ct-series-i .ct-line,
.ct-series-i .ct-bar,
.ct-series-i .ct-slice-donut {
  stroke: #35465c;
}

.ct-series-i .ct-slice-pie,
.ct-series-i .ct-area {
  fill: #35465c;
}

.ct-series-j .ct-point,
.ct-series-j .ct-line,
.ct-series-j .ct-bar,
.ct-series-j .ct-slice-donut {
  stroke: #e52d27;
}

.ct-series-j .ct-slice-pie,
.ct-series-j .ct-area {
  fill: #e52d27;
}

.ct-series-k .ct-point,
.ct-series-k .ct-line,
.ct-series-k .ct-bar,
.ct-series-k .ct-slice-donut {
  stroke: #55acee;
}

.ct-series-k .ct-slice-pie,
.ct-series-k .ct-area {
  fill: #55acee;
}

.ct-series-l .ct-point,
.ct-series-l .ct-line,
.ct-series-l .ct-bar,
.ct-series-l .ct-slice-donut {
  stroke: #cc2127;
}

.ct-series-l .ct-slice-pie,
.ct-series-l .ct-area {
  fill: #cc2127;
}

.ct-series-m .ct-point,
.ct-series-m .ct-line,
.ct-series-m .ct-bar,
.ct-series-m .ct-slice-donut {
  stroke: #1769ff;
}

.ct-series-m .ct-slice-pie,
.ct-series-m .ct-area {
  fill: #1769ff;
}

.ct-series-n .ct-point,
.ct-series-n .ct-line,
.ct-series-n .ct-bar,
.ct-series-n .ct-slice-donut {
  stroke: #6188e2;
}

.ct-series-n .ct-slice-pie,
.ct-series-n .ct-area {
  fill: #6188e2;
}

.ct-series-o .ct-point,
.ct-series-o .ct-line,
.ct-series-o .ct-bar,
.ct-series-o .ct-slice-donut {
  stroke: #a748ca;
}

.ct-series-o .ct-slice-pie,
.ct-series-o .ct-area {
  fill: #a748ca;
}

.ct-square {
  display: block;
  position: relative;
  width: 100%;
}
.ct-square:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 100%;
}
.ct-square:after {
  content: '';
  display: table;
  clear: both;
}
.ct-square > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-second:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 93.75%;
}
.ct-minor-second:after {
  content: '';
  display: table;
  clear: both;
}
.ct-minor-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-second:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 88.88889%;
}
.ct-major-second:after {
  content: '';
  display: table;
  clear: both;
}
.ct-major-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-third:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 83.33333%;
}
.ct-minor-third:after {
  content: '';
  display: table;
  clear: both;
}
.ct-minor-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-third:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 80%;
}
.ct-major-third:after {
  content: '';
  display: table;
  clear: both;
}
.ct-major-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fourth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fourth:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 75%;
}
.ct-perfect-fourth:after {
  content: '';
  display: table;
  clear: both;
}
.ct-perfect-fourth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fifth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fifth:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 66.66667%;
}
.ct-perfect-fifth:after {
  content: '';
  display: table;
  clear: both;
}
.ct-perfect-fifth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-sixth:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 62.5%;
}
.ct-minor-sixth:after {
  content: '';
  display: table;
  clear: both;
}
.ct-minor-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-golden-section {
  display: block;
  position: relative;
  width: 100%;
}
.ct-golden-section:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 61.8047%;
}
.ct-golden-section:after {
  content: '';
  display: table;
  clear: both;
}
.ct-golden-section > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-sixth:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 60%;
}
.ct-major-sixth:after {
  content: '';
  display: table;
  clear: both;
}
.ct-major-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-seventh:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 56.25%;
}
.ct-minor-seventh:after {
  content: '';
  display: table;
  clear: both;
}
.ct-minor-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-seventh:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 53.33333%;
}
.ct-major-seventh:after {
  content: '';
  display: table;
  clear: both;
}
.ct-major-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-octave:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 50%;
}
.ct-octave:after {
  content: '';
  display: table;
  clear: both;
}
.ct-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-tenth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-tenth:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 40%;
}
.ct-major-tenth:after {
  content: '';
  display: table;
  clear: both;
}
.ct-major-tenth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-eleventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-eleventh:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 37.5%;
}
.ct-major-eleventh:after {
  content: '';
  display: table;
  clear: both;
}
.ct-major-eleventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-twelfth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-twelfth:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 33.33333%;
}
.ct-major-twelfth:after {
  content: '';
  display: table;
  clear: both;
}
.ct-major-twelfth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-double-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-double-octave:before {
  display: block;
  float: left;
  content: '';
  width: 0;
  height: 0;
  padding-bottom: 25%;
}
.ct-double-octave:after {
  content: '';
  display: table;
  clear: both;
}
.ct-double-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

@media (min-width: 992px) {
  .navbar-form {
    margin-top: 21px;
    margin-bottom: 21px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .navbar-nav > li > .dropdown-menu,
  .dropdown .dropdown-menu {
    transform: scale(0);
    transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);
  }
  .navbar-nav > li.open > .dropdown-menu,
  .dropdown.open .dropdown-menu {
    transform: scale(1);
    transform-origin: 29px -50px;
  }
  .navbar-nav > li > .dropdown-menu:before {
    border-bottom: 11px solid rgba(0, 0, 0, 0.2);
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    content: '';
    display: inline-block;
    position: absolute;
    left: 12px;
    top: -11px;
  }
  .navbar-nav > li > .dropdown-menu:after {
    border-bottom: 11px solid #ffffff;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    content: '';
    display: inline-block;
    position: absolute;
    left: 12px;
    top: -10px;
  }
  .navbar-nav.navbar-right > li > .dropdown-menu:before {
    left: auto;
    right: 12px;
  }
  .navbar-nav.navbar-right > li > .dropdown-menu:after {
    left: auto;
    right: 12px;
  }
  .footer:not(.footer-big) nav > ul li:first-child {
    margin-left: 0;
  }
  body > .navbar-collapse.collapse {
    display: none !important;
  }
  .card form [class*='col-'] {
    padding: 6px;
  }
  .card form [class*='col-']:first-child {
    padding-left: 15px;
  }
  .card form [class*='col-']:last-child {
    padding-right: 15px;
  }
}

/*          Changes for small display      */
@media (max-width: 991px) {
  .main-panel {
    width: 100%;
  }
  .navbar-transparent {
    padding-top: 15px;
    background-color: rgba(0, 0, 0, 0.45);
  }
  body {
    position: relative;
  }
  .main-panel {
    transform: translate3d(0px, 0, 0);
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
    left: 0;
  }
  .navbar .container {
    left: 0;
    width: 100%;
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
    position: relative;
  }
  .navbar .navbar-collapse.collapse,
  .navbar .navbar-collapse.collapse.in,
  .navbar .navbar-collapse.collapsing {
    display: none !important;
  }
  .navbar-nav > li {
    float: none;
    position: relative;
    display: block;
  }
  .sidebar {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    width: 260px;
    right: 0;
    left: auto;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding: 0;
    transform: translate3d(260px, 0, 0);
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .sidebar > ul {
    position: relative;
    z-index: 4;
    overflow-y: scroll;
    height: calc(100vh - 61px);
    width: 100%;
  }
  .sidebar::before {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: #282828;
    display: block;
    content: '';
    z-index: 1;
  }
  .sidebar .sidebar-wrapper .dropdown-menu > li:first-child > a,
  .sidebar .sidebar-wrapper .dropdown-menu > li:last-child > a {
    border-radius: 4px;
  }
  .sidebar .sidebar-wrapper .dropdown-menu > li > a:hover,
  .sidebar .sidebar-wrapper .dropdown-menu > li > a:focus {
    color: white;
  }
  .sidebar .sidebar-wrapper > .nav > div .nav {
    margin-top: 10px;
    float: none !important;
  }
  .sidebar .sidebar-wrapper > .nav > div .nav > li > a {
    margin: 0;
    line-height: 30px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    margin: 5px 15px;
  }
  .sidebar .sidebar-wrapper > .nav > div .notification {
    float: left;
    line-height: 30px;
    margin-right: 8px;
    font-weight: 600;
  }
  .sidebar .open .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
  }
  .nav-open .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .navbar .container {
    left: -260px;
  }
  .nav-open .main-panel {
    left: 0;
    transform: translate3d(-260px, 0, 0);
  }
  .navbar-toggle .icon-bar {
    display: block;
    position: relative;
    background: #fff;
    width: 24px;
    height: 2px;
    border-radius: 1px;
    margin: 0 auto;
  }
  .navbar-header .navbar-toggle {
    margin: 10px 15px 10px 0;
    width: 40px;
    height: 40px;
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .dropdown-menu .divider {
    background-color: rgba(229, 229, 229, 0.15);
  }
  .navbar-nav {
    margin: 1px 0;
  }
  .navbar-nav .open .dropdown-menu > li > a {
    padding: 15px 15px 5px 50px;
  }
  .navbar-nav .open .dropdown-menu > li:first-child > a {
    padding: 5px 15px 5px 50px;
  }
  .navbar-nav .open .dropdown-menu > li:last-child > a {
    padding: 15px 15px 25px 50px;
  }
  [class*='navbar-'] .navbar-nav > li > a,
  [class*='navbar-'] .navbar-nav > li > a:hover,
  [class*='navbar-'] .navbar-nav > li > a:focus,
  [class*='navbar-'] .navbar-nav .active > a,
  [class*='navbar-'] .navbar-nav .active > a:hover,
  [class*='navbar-'] .navbar-nav .active > a:focus,
  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a,
  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a:hover,
  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a:focus,
  [class*='navbar-']
    .navbar-nav
    .navbar-nav
    .open
    .dropdown-menu
    > li
    > a:active {
    color: white;
  }
  [class*='navbar-'] .navbar-nav > li > a,
  [class*='navbar-'] .navbar-nav > li > a:hover,
  [class*='navbar-'] .navbar-nav > li > a:focus,
  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a,
  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a:hover,
  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a:focus {
    opacity: 0.7;
    background: transparent;
  }
  [class*='navbar-']
    .navbar-nav.navbar-nav
    .open
    .dropdown-menu
    > li
    > a:active {
    opacity: 1;
  }
  [class*='navbar-'] .navbar-nav .dropdown > a:hover .caret {
    border-bottom-color: #777;
    border-top-color: #777;
  }
  [class*='navbar-'] .navbar-nav .dropdown > a:active .caret {
    border-bottom-color: white;
    border-top-color: white;
  }
  .dropdown-menu {
    display: none;
  }
  .navbar-fixed-top {
    -webkit-backface-visibility: hidden;
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 0;
    top: 0;
    left: auto;
    right: 250px;
    content: '';
    z-index: 9999;
    overflow-x: hidden;
  }
  .social-line .btn {
    margin: 0 0 10px 0;
  }
  .subscribe-line .form-control {
    margin: 0 0 10px 0;
  }
  .social-line.pull-right {
    float: none;
  }
  .footer nav.pull-left {
    float: none !important;
  }
  .footer:not(.footer-big) nav > ul li {
    float: none;
  }
  .social-area.pull-right {
    float: none !important;
  }
  .form-control + .form-control-feedback {
    margin-top: -8px;
  }
  .navbar-toggle:hover,
  .navbar-toggle:focus {
    background-color: transparent !important;
  }
  .btn.dropdown-toggle {
    margin-bottom: 0;
  }
  .media-post .author {
    width: 20%;
    float: none !important;
    display: block;
    margin: 0 auto 10px;
  }
  .media-post .media-body {
    width: 100%;
  }
  .navbar-collapse.collapse {
    height: 100% !important;
  }
  .navbar-collapse.collapse.in {
    display: block;
  }
  .navbar-header .collapse,
  .navbar-toggle {
    display: block !important;
  }
  .navbar-header {
    float: none;
  }
  .navbar-nav .open .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
  }
  .navbar-collapse .nav p {
    font-size: 14px;
    margin: 0;
  }
  .navbar-collapse [class^='pe-7s-'] {
    float: left;
    font-size: 20px;
    margin-right: 10px;
  }
}

@media (min-width: 992px) {
  .table-full-width {
    margin-left: -15px;
    margin-right: -15px;
  }
  .table-responsive {
    overflow: visible;
  }
}

@media (max-width: 991px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-overflow-scrolling: touch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/sass/light-bootstrap-dashboard.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;AACF,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,oCAAoC;EAEpC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EAIV,wDAAwD;AAC1D;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AA6BA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AA6BA,kCAAkC;AAClC;;;;;;;;;;;;;;;;;;;;;;EAsBE,kCAAkC;EAClC,mCAAmC;EACnC,0DAA0D;EAC1D,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,6DAAiE;EACjE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;;;;;;;;EAQE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,UAAU;AACZ;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;;;;;EASE,4BAA4B;AAC9B;;AAEA;;EAME,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EAKE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,YAAY;EACZ,cAAc;EACd,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,2DAA2D;AAC7D;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;;;;EAIE,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;EACV,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,iDAAiD;AACnD;AACA;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,2DAA2D;AAC7D;AACA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EAYnB,6DAA6D;EAC7D,0BAA0B;EAC1B,UAAU;EACV,UAAU;AACZ;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EAYnB,gEAAgE;EAChE,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EAYnB,gEAAgE;EAChE,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EAYnB,gEAAgE;EAChE,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EAYnB,gEAAgE;EAChE,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EAYnB,gEAAgE;EAChE,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EAYnB,gEAAgE;EAChE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;;AAEA;;EAGE,gCAAgC;EAEhC,+BAA+B;EAE/B,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,UAAU;EACV,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;;;EAIE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,YAAY;EAEZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EAEzB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,SAAS;AACX;;AAEA;;;;;;EAME,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA,oCAAoC;AACpC;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,QAAQ;EACR,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,OAAO;EACP,MAAM;EACN,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;GAOG;AACH;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EAGzB,iBAAiB;EACjB,sBAAsB;EAItB,wEAAwE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,MAAM;EACN,kBAAkB;EAElB,+BAA+B;AACjC;;AAEA;;;EAKE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;EAC7B,MAAM;EACN,OAAO;EACP,SAAS;EACT,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;;;;;;;EASE,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EAGE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EAGV;oCACkC;AACpC;;AAEA;;;EAGE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;;EAGE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,QAAQ;EACR,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;AACA;;;;EAIE,6BAA6B;EAC7B,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;;;;EAME,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;;;;;EAME,6BAA6B;EAC7B,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,qBAAqB;EACrB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;EACE,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;EAEE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,SAAS;EACT,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EAExB,4CAA4C;AAC9C;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAE5B,gBAAgB;EAKhB,2BAA2B;EAK3B,mBAAmB;EAKnB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,wCAAwC;AAC1C;AACA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAGlB,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EAGR,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;EACZ,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EAKd,aAAa;AACf;;AAEA;EAIE,qBAAqB;EAIrB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAIE,uBAAuB;EAIvB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAIE,qBAAqB;EAIrB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAIE,qBAAqB;EAIrB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAIE,qBAAqB;EAIrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EAIE,uBAAuB;EAIvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EAIE,qBAAqB;EAIrB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAIE,uBAAuB;EAIvB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAIE,mBAAmB;EAInB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAIE,mBAAmB;EAInB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;;IAME,mBAAmB;IAKnB,sDAAsD;EACxD;EACA;;IAME,mBAAmB;IAKnB,4BAA4B;EAC9B;EACA;IACE,4CAA4C;IAC5C,mCAAmC;IACnC,oCAAoC;IACpC,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,mCAAmC;IACnC,oCAAoC;IACpC,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,qCAAqC;EACvC;EACA;IACE,kBAAkB;EACpB;EACA;IAKE,iCAAiC;IAKjC,2DAA2D;IAC3D,OAAO;EACT;EACA;IACE,OAAO;IACP,WAAW;IAKX,2DAA2D;IAC3D,kBAAkB;EACpB;EACA;;;IAGE,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,eAAe;IACf,cAAc;IACd,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IAKV,mCAAmC;IAKnC,2DAA2D;EAC7D;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;EACb;EACA;IACE,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,UAAU;EACZ;EACA;;IAEE,kBAAkB;EACpB;EACA;;IAEE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,SAAS;IAET,gBAAgB;EAClB;EACA;IAKE,iCAAiC;EACnC;EACA;IACE,YAAY;EACd;EACA;IACE,OAAO;IAKP,oCAAoC;EACtC;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,wBAAwB;IACxB,WAAW;IACX,YAAY;EACd;EACA;;;IAGE,8BAA8B;EAChC;EACA;IACE,QAAQ;IAGR,+BAA+B;IAG/B,6BAA6B;EAC/B;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IAGX,kCAAkC;IAGlC,6BAA6B;EAC/B;EACA;IACE,QAAQ;IAGR,4BAA4B;IAG5B,6BAA6B;EAC/B;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IAGX,+BAA+B;IAG/B,6BAA6B;EAC/B;EACA;IACE;MACE,QAAQ;MACR,uBAAuB;IACzB;IACA;MACE,QAAQ;MACR,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;EACF;EAiCA;IACE;MACE,QAAQ;MACR,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,uBAAuB;IACzB;IACA;MACE,QAAQ;MACR,oBAAoB;IACtB;EACF;EAiCA;IACE;MACE,WAAW;MACX,uBAAuB;IACzB;IACA;MACE,WAAW;MACX,0BAA0B;IAC5B;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,0BAA0B;IAC5B;EACF;EAiCA;IACE;MACE,WAAW;MACX,0BAA0B;IAC5B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,WAAW;MACX,oBAAoB;IACtB;EACF;EAiDA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;;;;;;;;;;;;;;;;IAgBE,YAAY;EACd;EACA;;;;;;IAME,YAAY;IACZ,uBAAuB;EACzB;EACA;;;;;;IAME,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,mCAAmC;EACrC;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,MAAM;IACN,UAAU;IACV,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,wCAAwC;EAC1C;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,sBAAsB;IACtB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,SAAS;IAET,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;IAC5C,iCAAiC;EACnC;AACF","sourcesContent":["/*!\n\n =========================================================\n * Light Bootstrap Dashboard React - v1.2.0\n * Based on Light Bootstrap Dashboard - v1.3.0\n =========================================================\n\n * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard-react\n * Copyright 2017 Creative Tim (http://www.creative-tim.com)\n * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n/*      light colors         */\nbody.react-confirm-alert-body-element {\n  overflow: hidden;\n}\n\n.react-confirm-alert-blur {\n  filter: url(#gaussian-blur);\n  filter: blur(2px);\n  -webkit-filter: blur(2px);\n}\n\n.react-confirm-alert-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99;\n  background: rgba(255, 255, 255, 0.9);\n  display: -webkit-flex;\n  display: -moz-flex;\n  display: -ms-flex;\n  display: -o-flex;\n  display: flex;\n  justify-content: center;\n  -ms-align-items: center;\n  align-items: center;\n  opacity: 0;\n  -webkit-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  -moz-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  -o-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n}\n\n.react-confirm-alert-body {\n  font-family: Arial, Helvetica, sans-serif;\n  padding: 30px;\n  text-align: left;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);\n  color: #666;\n}\n\n.react-confirm-alert-svg {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.react-confirm-alert-body > h1 {\n  margin-top: 0;  \n}\n\n.react-confirm-alert-body > h3 {\n  margin: 0;\n  font-size: 16px;\n}\n\n.react-confirm-alert-button-group {\n  display: -webkit-flex;\n  display: -moz-flex;\n  display: -ms-flex;\n  display: -o-flex;\n  display: flex;\n  justify-content: flex-start;\n  margin-top: 20px;\n}\n\n.react-confirm-alert-button-group > button {\n  outline: none;\n  background: #337ab7;\n  border: none;\n  display: inline-block;\n  padding: 6px 18px;\n  color: #eee;\n  margin-right: 10px;\n  border-radius: 5px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.react-confirm-alert-button-group > button:hover {\n  outline: none;\n  background: #66ace9;\n  border: none;\n  display: inline-block;\n  padding: 6px 18px;\n  color: #eee;\n  margin-right: 10px;\n  border-radius: 5px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n@-webkit-keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@-moz-keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@-o-keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@-moz-keyframes spin {\n  from {\n    -moz-transform: rotate(0deg);\n  }\n  to {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@-ms-keyframes spin {\n  from {\n    -ms-transform: rotate(0deg);\n  }\n  to {\n    -ms-transform: rotate(360deg);\n  }\n}\n\n/*           Font Smoothing      */\nbody,\nh1,\n.h1,\nh2,\n.h2,\nh3,\n.h3,\nh4,\n.h4,\nh5,\n.h5,\nh6,\n.h6,\np,\n.navbar,\n.brand,\n.btn-simple,\n.alert,\na,\n.td-name,\ntd,\nbutton.close {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif;\n  font-weight: 400;\n}\n.landing {\n  position: relative;\n  background: url('../../assets/img/loginbackground.jpg') no-repeat;\n  background-size: cover;\n  background-position: center;\n  height: 100vh;\n  margin-top: -70px;\n  margin-bottom: -50px;\n}\n\n.landing-inner {\n  padding-top: 80px;\n}\n\n.dark-overlay {\n  background-color: rgba(0, 0, 0, 0.7);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\nh1,\n.h1,\nh2,\n.h2,\nh3,\n.h3,\nh4,\n.h4 {\n  font-weight: 300;\n  margin: 30px 0 15px;\n}\n\nh1,\n.h1 {\n  font-size: 52px;\n}\n\nh2,\n.h2 {\n  font-size: 36px;\n}\n\nh3,\n.h3 {\n  font-size: 28px;\n  margin: 20px 0 10px;\n}\n\nh4,\n.h4 {\n  font-size: 22px;\n  line-height: 30px;\n}\n\nh5,\n.h5 {\n  font-size: 16px;\n  margin-bottom: 15px;\n}\n\nh6,\n.h6 {\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\np {\n  font-size: 16px;\n  line-height: 1.5;\n}\n\nh1 small,\nh2 small,\nh3 small,\nh4 small,\nh5 small,\nh6 small,\n.h1 small,\n.h2 small,\n.h3 small,\n.h4 small,\n.h5 small,\n.h6 small,\nh1 .small,\nh2 .small,\nh3 .small,\nh4 .small,\nh5 .small,\nh6 .small,\n.h1 .small,\n.h2 .small,\n.h3 .small,\n.h4 .small,\n.h5 .small,\n.h6 .small {\n  color: #9a9a9a;\n  font-weight: 300;\n  line-height: 1.5;\n}\n\nh1 small,\nh2 small,\nh3 small,\nh1 .small,\nh2 .small,\nh3 .small {\n  font-size: 60%;\n}\n\nh1 .subtitle {\n  display: block;\n  margin: 0 0 30px;\n}\n\n.text-muted {\n  color: #9a9a9a;\n}\n\n.text-primary,\n.text-primary:hover {\n  color: #1d62f0 !important;\n}\n\n.text-info,\n.text-info:hover {\n  color: #1dc7ea !important;\n}\n\n.text-success,\n.text-success:hover {\n  color: #87cb16 !important;\n}\n\n.text-warning,\n.text-warning:hover {\n  color: #ff9500 !important;\n}\n\n.text-danger,\n.text-danger:hover {\n  color: #ff4a55 !important;\n}\n\n/*     General overwrite     */\nbody,\n.wrapper {\n  min-height: 100vh;\n  position: relative;\n  background-color: white;\n}\n\na {\n  color: #1dc7ea;\n}\na:hover,\na:focus {\n  color: #42d0ed;\n  text-decoration: none;\n}\n\na:focus,\na:active,\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner,\ninput[type='reset']::-moz-focus-inner,\ninput[type='button']::-moz-focus-inner,\ninput[type='submit']::-moz-focus-inner,\nselect::-moz-focus-inner,\ninput[type='file'] > input[type='button']::-moz-focus-inner {\n  outline: 0;\n}\n\n.ui-slider-handle:focus,\n.navbar-toggle,\ninput:focus {\n  outline: 0 !important;\n}\n\n/*           Animations              */\n.form-control,\n.input-group-addon,\n.tagsinput,\n.navbar,\n.navbar .alert {\n  -webkit-transition: all 300ms linear;\n  -moz-transition: all 300ms linear;\n  -o-transition: all 300ms linear;\n  -ms-transition: all 300ms linear;\n  transition: all 300ms linear;\n}\n\n.sidebar .nav a,\n.table > tbody > tr .td-actions .btn {\n  -webkit-transition: all 150ms ease-in;\n  -moz-transition: all 150ms ease-in;\n  -o-transition: all 150ms ease-in;\n  -ms-transition: all 150ms ease-in;\n  transition: all 150ms ease-in;\n}\n\n.pull-center {\n  float: none;\n  margin: 0 auto;\n}\n\n.btn {\n  -webkit-transition: all 100ms ease-in;\n  -moz-transition: all 100ms ease-in;\n  -o-transition: all 100ms ease-in;\n  -ms-transition: all 100ms ease-in;\n  transition: all 100ms ease-in;\n}\n\n.fa {\n  width: 18px;\n  text-align: center;\n}\n\n.margin-top {\n  margin-top: 50px;\n}\n\n.wrapper {\n  position: relative;\n  top: 0;\n  height: 100vh;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 260px;\n  display: block;\n  z-index: 1;\n  color: #fff;\n  font-weight: 200;\n  background-size: cover;\n  background-position: center center;\n}\n.sidebar .sidebar-wrapper {\n  position: relative;\n  height: calc(100vh - 75px);\n  overflow: auto;\n  width: 260px;\n  z-index: 4;\n  padding-bottom: 30px;\n}\n.sidebar .sidebar-background {\n  position: absolute;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n  display: block;\n  top: 0;\n  left: 0;\n  background-size: cover;\n  background-position: center center;\n}\n.sidebar .logo {\n  padding: 10px 30px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  position: relative;\n  z-index: 4;\n}\n.sidebar .logo p {\n  float: left;\n  font-size: 20px;\n  margin: 10px 10px;\n  color: #ffffff;\n  line-height: 20px;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.sidebar .logo a.logo-mini {\n  float: left;\n  text-align: center;\n  width: 30px;\n  margin-right: 15px;\n}\n.sidebar .logo a.logo-mini img {\n  width: 40px;\n  margin-left: -3px;\n  display: block;\n  margin-top: 2px;\n}\n.sidebar .logo a.logo-normal {\n  display: block;\n}\n.sidebar .logo .logo-img {\n  width: 34px;\n  display: inline-block;\n  height: 34px;\n  margin-left: -2px;\n  margin-top: -2px;\n  margin-right: 10px;\n  border-radius: 30px;\n  text-align: center;\n}\n.sidebar .logo-tim {\n  border-radius: 50%;\n  border: 1px solid #333;\n  display: block;\n  height: 61px;\n  width: 61px;\n  float: left;\n  overflow: hidden;\n}\n.sidebar .logo-tim img {\n  width: 60px;\n  height: 60px;\n}\n.sidebar .nav {\n  margin-top: 20px;\n}\n.sidebar .nav li > a {\n  color: #ffffff;\n  margin: 5px 15px;\n  opacity: 0.86;\n  border-radius: 4px;\n}\n.sidebar .nav li:hover > a,\n.sidebar .nav li.open > a,\n.sidebar .nav li.open > a:focus,\n.sidebar .nav li.open > a:hover {\n  background: rgba(255, 255, 255, 0.13);\n  opacity: 1;\n}\n.sidebar .nav li.active > a {\n  color: #ffffff;\n  opacity: 1;\n  background: rgba(255, 255, 255, 0.23);\n}\n.sidebar .nav p {\n  margin: 0;\n  line-height: 30px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.sidebar .nav .caret {\n  top: 24px;\n  position: absolute;\n  right: 15px;\n}\n.sidebar .nav i {\n  font-size: 28px;\n  float: left;\n  margin-right: 15px;\n  line-height: 30px;\n  width: 30px;\n  text-align: center;\n}\n\n.sidebar .logo,\nbody > .navbar-collapse .logo {\n  padding: 10px 30px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n.sidebar .logo p,\nbody > .navbar-collapse .logo p {\n  float: left;\n  font-size: 20px;\n  margin: 10px 10px;\n  color: #ffffff;\n  line-height: 20px;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.sidebar .logo .simple-text,\nbody > .navbar-collapse .logo .simple-text {\n  text-transform: uppercase;\n  padding: 5px 0px;\n  display: block;\n  font-size: 18px;\n  color: #ffffff;\n  font-weight: 400;\n  line-height: 30px;\n}\n\n.sidebar .logo-tim,\nbody > .navbar-collapse .logo-tim {\n  border-radius: 50%;\n  border: 1px solid #333;\n  display: block;\n  height: 61px;\n  width: 61px;\n  float: left;\n  overflow: hidden;\n}\n.sidebar .logo-tim img,\nbody > .navbar-collapse .logo-tim img {\n  width: 60px;\n  height: 60px;\n}\n\n.sidebar:after,\n.sidebar:before,\nbody > .navbar-collapse:after,\nbody > .navbar-collapse:before {\n  display: block;\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 2;\n}\n\n.sidebar:before,\nbody > .navbar-collapse:before {\n  opacity: 0.33;\n  background: #000000;\n}\n\n.sidebar:after,\nbody > .navbar-collapse:after {\n  background: #282828;\n  background: -moz-linear-gradient(top, #282828 0%, #111 100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #282828),\n    color-stop(100%, #111)\n  );\n  background: -webkit-linear-gradient(top, #282828 0%, #111 100%);\n  background: -o-linear-gradient(top, #282828 0%, #111 100%);\n  background: -ms-linear-gradient(top, #282828 0%, #111 100%);\n  background: linear-gradient(to bottom, #282828 0%, #111 100%);\n  background-size: 150% 150%;\n  z-index: 3;\n  opacity: 1;\n}\n\n.sidebar[data-image]:after,\n.sidebar.has-image:after,\nbody > .navbar-collapse[data-image]:after,\nbody > .navbar-collapse.has-image:after {\n  opacity: 0.77;\n}\n\n.sidebar[data-color='blue']:after,\nbody > .navbar-collapse[data-color='blue']:after {\n  background: #1b8dff;\n  background: -moz-linear-gradient(top, #1b8dff 0%, #2632c1 100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #1b8dff),\n    color-stop(100%, #2632c1)\n  );\n  background: -webkit-linear-gradient(top, #1b8dff 0%, #2632c1 100%);\n  background: -o-linear-gradient(top, #1b8dff 0%, #2632c1 100%);\n  background: -ms-linear-gradient(top, #1b8dff 0%, #2632c1 100%);\n  background: linear-gradient(to bottom, #1b8dff 0%, #2632c1 100%);\n  background-size: 150% 150%;\n}\n\n.sidebar[data-color='azure']:after,\nbody > .navbar-collapse[data-color='azure']:after {\n  background: #1dc7ea;\n  background: -moz-linear-gradient(top, #1dc7ea 0%, #4091ff 100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #1dc7ea),\n    color-stop(100%, #4091ff)\n  );\n  background: -webkit-linear-gradient(top, #1dc7ea 0%, #4091ff 100%);\n  background: -o-linear-gradient(top, #1dc7ea 0%, #4091ff 100%);\n  background: -ms-linear-gradient(top, #1dc7ea 0%, #4091ff 100%);\n  background: linear-gradient(to bottom, #1dc7ea 0%, #4091ff 100%);\n  background-size: 150% 150%;\n}\n\n.sidebar[data-color='green']:after,\nbody > .navbar-collapse[data-color='green']:after {\n  background: #87cb16;\n  background: -moz-linear-gradient(top, #87cb16 0%, #6dc030 100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #87cb16),\n    color-stop(100%, #6dc030)\n  );\n  background: -webkit-linear-gradient(top, #87cb16 0%, #6dc030 100%);\n  background: -o-linear-gradient(top, #87cb16 0%, #6dc030 100%);\n  background: -ms-linear-gradient(top, #87cb16 0%, #6dc030 100%);\n  background: linear-gradient(to bottom, #87cb16 0%, #6dc030 100%);\n  background-size: 150% 150%;\n}\n\n.sidebar[data-color='orange']:after,\nbody > .navbar-collapse[data-color='orange']:after {\n  background: #ffa534;\n  background: -moz-linear-gradient(top, #ffa534 0%, #ff5221 100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #ffa534),\n    color-stop(100%, #ff5221)\n  );\n  background: -webkit-linear-gradient(top, #ffa534 0%, #ff5221 100%);\n  background: -o-linear-gradient(top, #ffa534 0%, #ff5221 100%);\n  background: -ms-linear-gradient(top, #ffa534 0%, #ff5221 100%);\n  background: linear-gradient(to bottom, #ffa534 0%, #ff5221 100%);\n  background-size: 150% 150%;\n}\n\n.sidebar[data-color='red']:after,\nbody > .navbar-collapse[data-color='red']:after {\n  background: #fb404b;\n  background: -moz-linear-gradient(top, #fb404b 0%, #bb0502 100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #fb404b),\n    color-stop(100%, #bb0502)\n  );\n  background: -webkit-linear-gradient(top, #fb404b 0%, #bb0502 100%);\n  background: -o-linear-gradient(top, #fb404b 0%, #bb0502 100%);\n  background: -ms-linear-gradient(top, #fb404b 0%, #bb0502 100%);\n  background: linear-gradient(to bottom, #fb404b 0%, #bb0502 100%);\n  background-size: 150% 150%;\n}\n\n.sidebar[data-color='purple']:after,\nbody > .navbar-collapse[data-color='purple']:after {\n  background: #9368e9;\n  background: -moz-linear-gradient(top, #9368e9 0%, #943bea 100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #9368e9),\n    color-stop(100%, #943bea)\n  );\n  background: -webkit-linear-gradient(top, #9368e9 0%, #943bea 100%);\n  background: -o-linear-gradient(top, #9368e9 0%, #943bea 100%);\n  background: -ms-linear-gradient(top, #9368e9 0%, #943bea 100%);\n  background: linear-gradient(to bottom, #9368e9 0%, #943bea 100%);\n  background-size: 150% 150%;\n}\n\n.main-panel {\n  background: rgba(203, 203, 210, 0.15);\n  position: relative;\n  float: right;\n  width: calc(100% - 260px);\n}\n.main-panel > .content {\n  padding: 30px 15px;\n  min-height: calc(100% - 123px);\n}\n.main-panel > .footer {\n  border-top: 1px solid #e7e7e7;\n}\n.main-panel .navbar {\n  margin-bottom: 0;\n}\n\n.sidebar,\n.main-panel {\n  -webkit-transition-property: top, bottom;\n  transition-property: top, bottom;\n  -webkit-transition-duration: 0.2s, 0.2s;\n  transition-duration: 0.2s, 0.2s;\n  -webkit-transition-timing-function: linear, linear;\n  transition-timing-function: linear, linear;\n  -webkit-overflow-scrolling: touch;\n}\n\n.btn {\n  border-width: 2px;\n  background-color: transparent;\n  font-weight: 400;\n  opacity: 0.8;\n  filter: alpha(opacity=80);\n  padding: 8px 16px;\n  border-color: #888888;\n  color: #888888;\n}\n.btn:hover,\n.btn:focus,\n.btn:active,\n.btn.active,\n.open > .btn.dropdown-toggle {\n  background-color: transparent;\n  color: #777777;\n  border-color: #777777;\n}\n.btn.disabled,\n.btn.disabled:hover,\n.btn.disabled:focus,\n.btn.disabled.focus,\n.btn.disabled:active,\n.btn.disabled.active,\n.btn:disabled,\n.btn:disabled:hover,\n.btn:disabled:focus,\n.btn:disabled.focus,\n.btn:disabled:active,\n.btn:disabled.active,\n.btn[disabled],\n.btn[disabled]:hover,\n.btn[disabled]:focus,\n.btn[disabled].focus,\n.btn[disabled]:active,\n.btn[disabled].active,\nfieldset[disabled] .btn,\nfieldset[disabled] .btn:hover,\nfieldset[disabled] .btn:focus,\nfieldset[disabled] .btn.focus,\nfieldset[disabled] .btn:active,\nfieldset[disabled] .btn.active {\n  background-color: transparent;\n  border-color: #888888;\n}\n.btn.btn-fill {\n  color: #ffffff;\n  background-color: #888888;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn.btn-fill:hover,\n.btn.btn-fill:focus,\n.btn.btn-fill:active,\n.btn.btn-fill.active,\n.open > .btn.btn-fill.dropdown-toggle {\n  background-color: #777777;\n  color: #ffffff;\n}\n.btn.btn-fill .caret {\n  border-top-color: #ffffff;\n}\n.btn .caret {\n  border-top-color: #888888;\n}\n.btn:hover,\n.btn:focus {\n  opacity: 1;\n  filter: alpha(opacity=100);\n  outline: 0 !important;\n}\n.btn:active,\n.btn.active,\n.open > .btn.dropdown-toggle {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: 0 !important;\n}\n.btn.btn-icon {\n  padding: 8px;\n}\n\n.btn-primary {\n  border-color: #3472f7;\n  color: #3472f7;\n}\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active,\n.open > .btn-primary.dropdown-toggle {\n  background-color: transparent;\n  color: #1d62f0;\n  border-color: #1d62f0;\n}\n.btn-primary.disabled,\n.btn-primary.disabled:hover,\n.btn-primary.disabled:focus,\n.btn-primary.disabled.focus,\n.btn-primary.disabled:active,\n.btn-primary.disabled.active,\n.btn-primary:disabled,\n.btn-primary:disabled:hover,\n.btn-primary:disabled:focus,\n.btn-primary:disabled.focus,\n.btn-primary:disabled:active,\n.btn-primary:disabled.active,\n.btn-primary[disabled],\n.btn-primary[disabled]:hover,\n.btn-primary[disabled]:focus,\n.btn-primary[disabled].focus,\n.btn-primary[disabled]:active,\n.btn-primary[disabled].active,\nfieldset[disabled] .btn-primary,\nfieldset[disabled] .btn-primary:hover,\nfieldset[disabled] .btn-primary:focus,\nfieldset[disabled] .btn-primary.focus,\nfieldset[disabled] .btn-primary:active,\nfieldset[disabled] .btn-primary.active {\n  background-color: transparent;\n  border-color: #3472f7;\n}\n.btn-primary.btn-fill {\n  color: #ffffff;\n  background-color: #3472f7;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-primary.btn-fill:hover,\n.btn-primary.btn-fill:focus,\n.btn-primary.btn-fill:active,\n.btn-primary.btn-fill.active,\n.open > .btn-primary.btn-fill.dropdown-toggle {\n  background-color: #1d62f0;\n  color: #ffffff;\n}\n.btn-primary.btn-fill .caret {\n  border-top-color: #ffffff;\n}\n.btn-primary .caret {\n  border-top-color: #3472f7;\n}\n\n.btn-success {\n  border-color: #87cb16;\n  color: #87cb16;\n}\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active,\n.btn-success.active,\n.open > .btn-success.dropdown-toggle {\n  background-color: transparent;\n  color: #049f0c;\n  border-color: #049f0c;\n}\n.btn-success.disabled,\n.btn-success.disabled:hover,\n.btn-success.disabled:focus,\n.btn-success.disabled.focus,\n.btn-success.disabled:active,\n.btn-success.disabled.active,\n.btn-success:disabled,\n.btn-success:disabled:hover,\n.btn-success:disabled:focus,\n.btn-success:disabled.focus,\n.btn-success:disabled:active,\n.btn-success:disabled.active,\n.btn-success[disabled],\n.btn-success[disabled]:hover,\n.btn-success[disabled]:focus,\n.btn-success[disabled].focus,\n.btn-success[disabled]:active,\n.btn-success[disabled].active,\nfieldset[disabled] .btn-success,\nfieldset[disabled] .btn-success:hover,\nfieldset[disabled] .btn-success:focus,\nfieldset[disabled] .btn-success.focus,\nfieldset[disabled] .btn-success:active,\nfieldset[disabled] .btn-success.active {\n  background-color: transparent;\n  border-color: #87cb16;\n}\n.btn-success.btn-fill {\n  color: #ffffff;\n  background-color: #87cb16;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-success.btn-fill:hover,\n.btn-success.btn-fill:focus,\n.btn-success.btn-fill:active,\n.btn-success.btn-fill.active,\n.open > .btn-success.btn-fill.dropdown-toggle {\n  background-color: #049f0c;\n  color: #ffffff;\n}\n.btn-success.btn-fill .caret {\n  border-top-color: #ffffff;\n}\n.btn-success .caret {\n  border-top-color: #87cb16;\n}\n\n.btn-info {\n  border-color: #1dc7ea;\n  color: #1dc7ea;\n}\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active,\n.open > .btn-info.dropdown-toggle {\n  background-color: transparent;\n  color: #42d0ed;\n  border-color: #42d0ed;\n}\n.btn-info.disabled,\n.btn-info.disabled:hover,\n.btn-info.disabled:focus,\n.btn-info.disabled.focus,\n.btn-info.disabled:active,\n.btn-info.disabled.active,\n.btn-info:disabled,\n.btn-info:disabled:hover,\n.btn-info:disabled:focus,\n.btn-info:disabled.focus,\n.btn-info:disabled:active,\n.btn-info:disabled.active,\n.btn-info[disabled],\n.btn-info[disabled]:hover,\n.btn-info[disabled]:focus,\n.btn-info[disabled].focus,\n.btn-info[disabled]:active,\n.btn-info[disabled].active,\nfieldset[disabled] .btn-info,\nfieldset[disabled] .btn-info:hover,\nfieldset[disabled] .btn-info:focus,\nfieldset[disabled] .btn-info.focus,\nfieldset[disabled] .btn-info:active,\nfieldset[disabled] .btn-info.active {\n  background-color: transparent;\n  border-color: #1dc7ea;\n}\n.btn-info.btn-fill {\n  color: #ffffff;\n  background-color: #1dc7ea;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-info.btn-fill:hover,\n.btn-info.btn-fill:focus,\n.btn-info.btn-fill:active,\n.btn-info.btn-fill.active,\n.open > .btn-info.btn-fill.dropdown-toggle {\n  background-color: #42d0ed;\n  color: #ffffff;\n}\n.btn-info.btn-fill .caret {\n  border-top-color: #ffffff;\n}\n.btn-info .caret {\n  border-top-color: #1dc7ea;\n}\n\n.btn-warning {\n  border-color: #ff9500;\n  color: #ff9500;\n}\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active,\n.open > .btn-warning.dropdown-toggle {\n  background-color: transparent;\n  color: #ed8d00;\n  border-color: #ed8d00;\n}\n.btn-warning.disabled,\n.btn-warning.disabled:hover,\n.btn-warning.disabled:focus,\n.btn-warning.disabled.focus,\n.btn-warning.disabled:active,\n.btn-warning.disabled.active,\n.btn-warning:disabled,\n.btn-warning:disabled:hover,\n.btn-warning:disabled:focus,\n.btn-warning:disabled.focus,\n.btn-warning:disabled:active,\n.btn-warning:disabled.active,\n.btn-warning[disabled],\n.btn-warning[disabled]:hover,\n.btn-warning[disabled]:focus,\n.btn-warning[disabled].focus,\n.btn-warning[disabled]:active,\n.btn-warning[disabled].active,\nfieldset[disabled] .btn-warning,\nfieldset[disabled] .btn-warning:hover,\nfieldset[disabled] .btn-warning:focus,\nfieldset[disabled] .btn-warning.focus,\nfieldset[disabled] .btn-warning:active,\nfieldset[disabled] .btn-warning.active {\n  background-color: transparent;\n  border-color: #ff9500;\n}\n.btn-warning.btn-fill {\n  color: #ffffff;\n  background-color: #ff9500;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-warning.btn-fill:hover,\n.btn-warning.btn-fill:focus,\n.btn-warning.btn-fill:active,\n.btn-warning.btn-fill.active,\n.open > .btn-warning.btn-fill.dropdown-toggle {\n  background-color: #ed8d00;\n  color: #ffffff;\n}\n.btn-warning.btn-fill .caret {\n  border-top-color: #ffffff;\n}\n.btn-warning .caret {\n  border-top-color: #ff9500;\n}\n\n.btn-danger {\n  border-color: #ff4a55;\n  color: #ff4a55;\n}\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active,\n.open > .btn-danger.dropdown-toggle {\n  background-color: transparent;\n  color: #ee2d20;\n  border-color: #ee2d20;\n}\n.btn-danger.disabled,\n.btn-danger.disabled:hover,\n.btn-danger.disabled:focus,\n.btn-danger.disabled.focus,\n.btn-danger.disabled:active,\n.btn-danger.disabled.active,\n.btn-danger:disabled,\n.btn-danger:disabled:hover,\n.btn-danger:disabled:focus,\n.btn-danger:disabled.focus,\n.btn-danger:disabled:active,\n.btn-danger:disabled.active,\n.btn-danger[disabled],\n.btn-danger[disabled]:hover,\n.btn-danger[disabled]:focus,\n.btn-danger[disabled].focus,\n.btn-danger[disabled]:active,\n.btn-danger[disabled].active,\nfieldset[disabled] .btn-danger,\nfieldset[disabled] .btn-danger:hover,\nfieldset[disabled] .btn-danger:focus,\nfieldset[disabled] .btn-danger.focus,\nfieldset[disabled] .btn-danger:active,\nfieldset[disabled] .btn-danger.active {\n  background-color: transparent;\n  border-color: #ff4a55;\n}\n.btn-danger.btn-fill {\n  color: #ffffff;\n  background-color: #ff4a55;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-danger.btn-fill:hover,\n.btn-danger.btn-fill:focus,\n.btn-danger.btn-fill:active,\n.btn-danger.btn-fill.active,\n.open > .btn-danger.btn-fill.dropdown-toggle {\n  background-color: #ee2d20;\n  color: #ffffff;\n}\n.btn-danger.btn-fill .caret {\n  border-top-color: #ffffff;\n}\n.btn-danger .caret {\n  border-top-color: #ff4a55;\n}\n\n.btn-neutral {\n  border-color: #ffffff;\n  color: #ffffff;\n}\n.btn-neutral:hover,\n.btn-neutral:focus,\n.btn-neutral:active,\n.btn-neutral.active,\n.open > .btn-neutral.dropdown-toggle {\n  background-color: transparent;\n  color: #ffffff;\n  border-color: #ffffff;\n}\n.btn-neutral.disabled,\n.btn-neutral.disabled:hover,\n.btn-neutral.disabled:focus,\n.btn-neutral.disabled.focus,\n.btn-neutral.disabled:active,\n.btn-neutral.disabled.active,\n.btn-neutral:disabled,\n.btn-neutral:disabled:hover,\n.btn-neutral:disabled:focus,\n.btn-neutral:disabled.focus,\n.btn-neutral:disabled:active,\n.btn-neutral:disabled.active,\n.btn-neutral[disabled],\n.btn-neutral[disabled]:hover,\n.btn-neutral[disabled]:focus,\n.btn-neutral[disabled].focus,\n.btn-neutral[disabled]:active,\n.btn-neutral[disabled].active,\nfieldset[disabled] .btn-neutral,\nfieldset[disabled] .btn-neutral:hover,\nfieldset[disabled] .btn-neutral:focus,\nfieldset[disabled] .btn-neutral.focus,\nfieldset[disabled] .btn-neutral:active,\nfieldset[disabled] .btn-neutral.active {\n  background-color: transparent;\n  border-color: #ffffff;\n}\n.btn-neutral.btn-fill {\n  color: #ffffff;\n  background-color: #ffffff;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-neutral.btn-fill:hover,\n.btn-neutral.btn-fill:focus,\n.btn-neutral.btn-fill:active,\n.btn-neutral.btn-fill.active,\n.open > .btn-neutral.btn-fill.dropdown-toggle {\n  background-color: #ffffff;\n  color: #ffffff;\n}\n.btn-neutral.btn-fill .caret {\n  border-top-color: #ffffff;\n}\n.btn-neutral .caret {\n  border-top-color: #ffffff;\n}\n.btn-neutral:active,\n.btn-neutral.active,\n.open > .btn-neutral.dropdown-toggle {\n  background-color: #ffffff;\n  color: #888888;\n}\n.btn-neutral.btn-fill,\n.btn-neutral.btn-fill:hover,\n.btn-neutral.btn-fill:focus {\n  color: #888888;\n}\n.btn-neutral.btn-simple:active,\n.btn-neutral.btn-simple.active {\n  background-color: transparent;\n}\n\n.btn:disabled,\n.btn[disabled],\n.btn.disabled {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n}\n\n.btn-round {\n  border-width: 1px;\n  border-radius: 30px !important;\n  padding: 9px 18px;\n}\n.btn-round.btn-icon {\n  padding: 9px;\n}\n\n.btn-simple {\n  border: 0;\n  font-size: 16px;\n  padding: 8px 16px;\n}\n.btn-simple.btn-icon {\n  padding: 8px;\n}\n\n.btn-lg {\n  font-size: 18px;\n  border-radius: 6px;\n  padding: 14px 30px;\n  font-weight: 400;\n}\n.btn-lg.btn-round {\n  padding: 15px 30px;\n}\n.btn-lg.btn-simple {\n  padding: 16px 30px;\n}\n\n.btn-sm {\n  font-size: 12px;\n  border-radius: 3px;\n  padding: 5px 10px;\n}\n.btn-sm.btn-round {\n  padding: 6px 10px;\n}\n.btn-sm.btn-simple {\n  padding: 7px 10px;\n}\n\n.btn-xs {\n  font-size: 12px;\n  border-radius: 3px;\n  padding: 1px 5px;\n}\n.btn-xs.btn-round {\n  padding: 2px 5px;\n}\n.btn-xs.btn-simple {\n  padding: 3px 5px;\n}\n\n.btn-wd {\n  min-width: 140px;\n}\n\n.btn-group.select {\n  width: 100%;\n}\n\n.btn-group.select .btn {\n  text-align: left;\n}\n\n.btn-group.select .caret {\n  position: absolute;\n  top: 50%;\n  margin-top: -1px;\n  right: 8px;\n}\n\n.form-control::-moz-placeholder {\n  color: #dddddd;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n.form-control:-moz-placeholder {\n  color: #dddddd;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n.form-control::-webkit-input-placeholder {\n  color: #dddddd;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n.form-control:-ms-input-placeholder {\n  color: #dddddd;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n.form-control {\n  background-color: #ffffff;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  color: #565656;\n  padding: 8px 12px;\n  height: 40px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.form-control:focus {\n  background-color: #ffffff;\n  border: 1px solid #aaaaaa;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: 0 !important;\n  color: #333333;\n}\n.has-success .form-control,\n.has-error .form-control,\n.has-success .form-control:focus,\n.has-error .form-control:focus {\n  border-color: #e3e3e3;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.has-success .form-control {\n  color: #87cb16;\n}\n.has-success .form-control:focus {\n  border-color: #87cb16;\n}\n.has-error .form-control {\n  color: #ff4a55;\n}\n.has-error .form-control:focus {\n  border-color: #ff4a55;\n}\n.form-control + .form-control-feedback {\n  border-radius: 6px;\n  font-size: 14px;\n  margin-top: -7px;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  vertical-align: middle;\n}\n.open .form-control {\n  border-radius: 4px 4px 0 0;\n  border-bottom-color: transparent;\n}\n\n.input-lg {\n  height: 55px;\n  padding: 14px 30px;\n}\n\n.has-error .form-control-feedback {\n  color: #ff4a55;\n}\n\n.has-success .form-control-feedback {\n  color: #87cb16;\n}\n\n.input-group-addon {\n  background-color: #ffffff;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n}\n.has-success .input-group-addon,\n.has-error .input-group-addon {\n  background-color: #ffffff;\n  border: 1px solid #e3e3e3;\n}\n.has-error .form-control:focus + .input-group-addon {\n  border-color: #ff4a55;\n  color: #ff4a55;\n}\n.has-success .form-control:focus + .input-group-addon {\n  border-color: #87cb16;\n  color: #87cb16;\n}\n.form-control:focus + .input-group-addon,\n.form-control:focus ~ .input-group-addon {\n  background-color: #ffffff;\n  border-color: #9a9a9a;\n}\n\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n  border-right: 0 none;\n}\n\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n  border-left: 0 none;\n}\n\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: #f5f5f5;\n  color: #888888;\n  cursor: not-allowed;\n}\n\n.input-group-btn .btn {\n  border-width: 1px;\n  padding: 9px 16px;\n}\n\n.input-group-btn .btn-default:not(.btn-fill) {\n  border-color: #dddddd;\n}\n\n.input-group-btn:last-child > .btn {\n  margin-left: 0;\n}\n\n.input-group-focus .input-group-addon {\n  border-color: #9a9a9a;\n}\n\n.alert {\n  border: 0;\n  border-radius: 0;\n  color: #ffffff;\n  padding: 10px 15px;\n  font-size: 14px;\n}\n.container .alert {\n  border-radius: 4px;\n}\n.navbar .alert {\n  border-radius: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 85px;\n  width: 100%;\n  z-index: 3;\n}\n.navbar:not(.navbar-transparent) .alert {\n  top: 70px;\n}\n.alert span[data-notify='icon'] {\n  font-size: 30px;\n  display: block;\n  left: 15px;\n  position: absolute;\n  top: 50%;\n  margin-top: -15px;\n}\n.alert button.close {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  margin-top: -13px;\n  z-index: 1033;\n  background-color: #ffffff;\n  display: block;\n  border-radius: 50%;\n  opacity: 0.4;\n  line-height: 20px;\n  font-size: 12px;\n  width: 25px;\n  height: 25px;\n  outline: 0 !important;\n  text-align: center;\n  padding: 3px;\n  font-weight: 300;\n}\n.alert button.close:hover {\n  opacity: 0.55;\n}\n.alert .close ~ span {\n  display: block;\n  max-width: 89%;\n}\n.alert[data-notify='container'] {\n  padding: 10px 10px 10px 20px;\n  border-radius: 4px;\n}\n.alert.alert-with-icon {\n  padding-left: 65px;\n}\n.alert a,\n.alert a:hover,\n.alert a:focus {\n  text-decoration: underline;\n  color: white;\n}\n\n.alert-info {\n  background-color: #63d8f1;\n}\n\n.alert-success {\n  background-color: #a1e82c;\n}\n\n.alert-warning {\n  background-color: #ffbc67;\n}\n\n.alert-danger {\n  background-color: #fc727a;\n}\n\n.table .radio,\n.table .checkbox {\n  position: relative;\n  height: 20px;\n  display: block;\n  width: 20px;\n  padding: 0px 0px;\n  margin: 0px 5px;\n  text-align: center;\n}\n.table .radio .icons,\n.table .checkbox .icons {\n  left: 5px;\n}\n\n.table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n  padding: 12px 8px;\n  vertical-align: middle;\n}\n\n.table > tbody > tr > td {\n  font-size: 14px;\n}\n\n.table > thead > tr > th {\n  border-bottom-width: 1px;\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #9a9a9a;\n  font-weight: 400;\n  padding-bottom: 5px;\n}\n\n.table .td-actions .btn {\n  opacity: 0.36;\n  filter: alpha(opacity=36);\n}\n.table .td-actions .btn.btn-xs {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n.table .td-actions {\n  min-width: 90px;\n}\n\n.table > tbody > tr {\n  position: relative;\n}\n.table > tbody > tr:hover .td-actions .btn {\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n/*      Checkbox and radio         */\n.checkbox,\n.radio {\n  margin-bottom: 12px;\n}\n\n.checkbox label,\n.radio label {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  padding-left: 24px;\n  margin-bottom: 0;\n}\n\n.checkbox label::before,\n.checkbox label::after {\n  font-family: 'FontAwesome';\n  content: '\\f096';\n  display: inline-block;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  left: 0;\n  cursor: pointer;\n  line-height: 19px;\n  font-size: 20px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  top: 1px;\n  color: #dddddd;\n  transition: color 0.2s linear;\n  padding: 1px;\n}\n\n.checkbox label::after {\n  content: '';\n  text-align: center;\n  opacity: 1;\n  left: 1px;\n  color: #dddddd;\n}\n\n.checkbox input[type='checkbox'],\n.radio input[type='radio'] {\n  opacity: 0;\n  margin-left: 0;\n}\n\n.checkbox input[type='checkbox']:checked + label::after {\n  font-family: 'FontAwesome';\n  content: '\\f046';\n}\n\n.checkbox input[type='checkbox']:checked + label::after {\n  color: #1dc7ea;\n}\n\n.checkbox input[type='checkbox']:checked + label::before {\n  opacity: 0;\n}\n\n.checkbox input[type='checkbox']:disabled + label,\n.radio input[type='radio']:disabled + label,\n.checkbox input[type='checkbox']:disabled:checked + label::after {\n  color: #dddddd;\n}\n\n.checkbox input[type='checkbox']:disabled + label::before,\n.checkbox input[type='checkbox']:disabled + label::after {\n  cursor: not-allowed;\n}\n\n.checkbox input[type='checkbox']:disabled + label,\n.radio input[type='radio']:disabled + label {\n  cursor: not-allowed;\n}\n\n.checkbox.checkbox-circle label::before {\n  border-radius: 50%;\n}\n\n.checkbox.checkbox-inline {\n  padding-left: 0;\n}\n\n.checkbox-primary input[type='checkbox']:checked + label::before {\n  background-color: #428bca;\n  border-color: #428bca;\n}\n\n.checkbox-primary input[type='checkbox']:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-danger input[type='checkbox']:checked + label::before {\n  background-color: #d9534f;\n  border-color: #d9534f;\n}\n\n.checkbox-danger input[type='checkbox']:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-info input[type='checkbox']:checked + label::before {\n  background-color: #5bc0de;\n  border-color: #5bc0de;\n}\n\n.checkbox-info input[type='checkbox']:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-warning input[type='checkbox']:checked + label::before {\n  background-color: #f0ad4e;\n  border-color: #f0ad4e;\n}\n\n.checkbox-warning input[type='checkbox']:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-success input[type='checkbox']:checked + label::before {\n  background-color: #5cb85c;\n  border-color: #5cb85c;\n}\n\n.checkbox-success input[type='checkbox']:checked + label::after {\n  color: #fff;\n}\n\n.radio label::before,\n.radio label::after {\n  font-family: 'FontAwesome';\n  content: '\\f10c';\n  font-size: 20px;\n  height: 20px;\n  width: 20px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  position: absolute;\n  line-height: 19px;\n  left: 0;\n  top: 0;\n  color: #dddddd;\n  padding: 1px;\n  transition: color 0.2s linear;\n}\n\n.radio input[type='radio']:checked + label::after {\n  font-family: 'FontAwesome';\n  content: '\\f192';\n  color: #dddddd;\n}\n\n.radio input[type='radio']:checked + label::after {\n  color: #1dc7ea;\n}\n\n.radio input[type='radio']:disabled + label {\n  color: #ddd;\n}\n\n.radio input[type='radio']:disabled + label::before,\n.radio input[type='radio']:disabled + label::after {\n  color: #ddd;\n}\n\n.radio.radio-inline {\n  margin-top: 0;\n}\n\n/**\n  * bootstrap-switch - Turn checkboxes and radio buttons into toggle switches.\n  *\n  * @version v3.3.4\n  * @homepage https://bttstrp.github.io/bootstrap-switch\n  * @author Mattia Larentis <mattia@larentis.eu> (http://larentis.eu)\n  * @license Apache-2.0\n  */\n.bootstrap-switch {\n  display: inline-block;\n  direction: ltr;\n  cursor: pointer;\n  border-radius: 4px;\n  border: 1px solid;\n  border-color: #ccc;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n  line-height: 8px;\n  z-index: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  -webkit-transition: border-color ease-in-out 0.15s,\n    box-shadow ease-in-out 0.15s;\n  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n  display: inline-block;\n  top: 0;\n  border-radius: 4px;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: table-cell;\n  vertical-align: middle;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-align: center;\n  z-index: 1;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {\n  color: #fff;\n  background: #337ab7;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {\n  color: #fff;\n  background: #5bc0de;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {\n  color: #fff;\n  background: #5cb85c;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {\n  background: #f0ad4e;\n  color: #fff;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {\n  color: #fff;\n  background: #d9534f;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n  color: #000;\n  background: #eeeeee;\n}\n\n.bootstrap-switch .bootstrap-switch-label {\n  text-align: center;\n  margin-top: -1px;\n  margin-bottom: -1px;\n  z-index: 100;\n  color: #333;\n  background: #fff;\n}\n\n.bootstrap-switch span::before {\n  content: '\\200b';\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off {\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.bootstrap-switch input[type='radio'],\n.bootstrap-switch input[type='checkbox'] {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  margin: 0;\n  z-index: -1;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  visibility: hidden;\n}\n\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n  padding: 6px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled,\n.bootstrap-switch.bootstrap-switch-readonly,\n.bootstrap-switch.bootstrap-switch-indeterminate {\n  cursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n  -webkit-transition: margin-left 0.5s;\n  -o-transition: margin-left 0.5s;\n  transition: margin-left 0.5s;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-focused {\n  border-color: #66afe9;\n  outline: 0;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),\n    0 0 8px rgba(102, 175, 233, 0.6);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),\n    0 0 8px rgba(102, 175, 233, 0.6);\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-off\n  .bootstrap-switch-label {\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-on\n  .bootstrap-switch-label {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.nav > li > a:hover,\n.nav > li > a:focus {\n  background-color: transparent;\n}\n\n.navbar {\n  border: 0;\n  font-size: 16px;\n  border-radius: 0;\n}\n.navbar .navbar-brand {\n  font-weight: 400;\n  margin: 5px 0px;\n  padding: 15px 15px;\n  font-size: 20px;\n}\n.navbar .navbar-nav > li > a {\n  padding: 10px 15px;\n  margin: 10px 3px;\n  position: relative;\n}\n.navbar .navbar-nav > li > a.btn {\n  margin: 15px 3px;\n  padding: 8px 16px;\n}\n.navbar .navbar-nav > li > a.btn-round {\n  margin: 16px 3px;\n}\n.navbar .navbar-nav > li > a [class^='fa'] {\n  font-size: 19px;\n  position: relative;\n  line-height: 16px;\n  top: 1px;\n}\n.navbar .navbar-nav .notification {\n  position: absolute;\n  background-color: #fb404b;\n  text-align: center;\n  border-radius: 10px;\n  min-width: 18px;\n  padding: 0 5px;\n  height: 18px;\n  font-size: 12px;\n  color: #ffffff;\n  font-weight: bold;\n  line-height: 18px;\n  top: 0px;\n  left: 7px;\n}\n.navbar .btn {\n  margin: 15px 3px;\n  font-size: 14px;\n}\n.navbar .btn-simple {\n  font-size: 16px;\n}\n.navbar.fixed {\n  width: calc(100%);\n  right: 0;\n  left: auto;\n  border-radius: 0;\n}\n\n.navbar-nav > li > .dropdown-menu {\n  border-radius: 10px;\n  margin-top: -5px;\n}\n\n.navbar-transparent .navbar-brand,\n[class*='navbar-ct'] .navbar-brand {\n  color: #ffffff;\n  opacity: 0.9;\n  filter: alpha(opacity=90);\n}\n.navbar-transparent .navbar-brand:focus,\n.navbar-transparent .navbar-brand:hover,\n[class*='navbar-ct'] .navbar-brand:focus,\n[class*='navbar-ct'] .navbar-brand:hover {\n  background-color: transparent;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n.navbar-transparent .navbar-nav > li > a:not(.btn),\n[class*='navbar-ct'] .navbar-nav > li > a:not(.btn) {\n  color: #ffffff;\n  border-color: #ffffff;\n  opacity: 0.8;\n  filter: alpha(opacity=80);\n}\n\n.navbar-transparent .navbar-nav > .active > a:not(.btn),\n.navbar-transparent .navbar-nav > .active > a:hover:not(.btn),\n.navbar-transparent .navbar-nav > .active > a:focus:not(.btn),\n.navbar-transparent .navbar-nav > li > a:hover:not(.btn),\n.navbar-transparent .navbar-nav > li > a:focus:not(.btn),\n[class*='navbar-ct'] .navbar-nav > .active > a:not(.btn),\n[class*='navbar-ct'] .navbar-nav > .active > a:hover:not(.btn),\n[class*='navbar-ct'] .navbar-nav > .active > a:focus:not(.btn),\n[class*='navbar-ct'] .navbar-nav > li > a:hover:not(.btn),\n[class*='navbar-ct'] .navbar-nav > li > a:focus:not(.btn) {\n  background-color: transparent;\n  border-radius: 3px;\n  color: #ffffff;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n.navbar-transparent .navbar-nav .nav > li > a.btn:hover,\n[class*='navbar-ct'] .navbar-nav .nav > li > a.btn:hover {\n  background-color: transparent;\n}\n\n.navbar-transparent .navbar-nav > .dropdown > a .caret,\n.navbar-transparent .navbar-nav > .dropdown > a:hover .caret,\n.navbar-transparent .navbar-nav > .dropdown > a:focus .caret,\n[class*='navbar-ct'] .navbar-nav > .dropdown > a .caret,\n[class*='navbar-ct'] .navbar-nav > .dropdown > a:hover .caret,\n[class*='navbar-ct'] .navbar-nav > .dropdown > a:focus .caret {\n  border-bottom-color: #ffffff;\n  border-top-color: #ffffff;\n}\n\n.navbar-transparent .navbar-nav > .open > a,\n.navbar-transparent .navbar-nav > .open > a:hover,\n.navbar-transparent .navbar-nav > .open > a:focus,\n[class*='navbar-ct'] .navbar-nav > .open > a,\n[class*='navbar-ct'] .navbar-nav > .open > a:hover,\n[class*='navbar-ct'] .navbar-nav > .open > a:focus {\n  background-color: transparent;\n  color: #ffffff;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n.navbar-transparent .btn-default,\n[class*='navbar-ct'] .btn-default {\n  color: #ffffff;\n  border-color: #ffffff;\n}\n\n.navbar-transparent .btn-default.btn-fill,\n[class*='navbar-ct'] .btn-default.btn-fill {\n  color: #9a9a9a;\n  background-color: #ffffff;\n  opacity: 0.9;\n  filter: alpha(opacity=90);\n}\n\n.navbar-transparent .btn-default.btn-fill:hover,\n.navbar-transparent .btn-default.btn-fill:focus,\n.navbar-transparent .btn-default.btn-fill:active,\n.navbar-transparent .btn-default.btn-fill.active,\n.navbar-transparent .open .dropdown-toggle.btn-fill.btn-default,\n[class*='navbar-ct'] .btn-default.btn-fill:hover,\n[class*='navbar-ct'] .btn-default.btn-fill:focus,\n[class*='navbar-ct'] .btn-default.btn-fill:active,\n[class*='navbar-ct'] .btn-default.btn-fill.active,\n[class*='navbar-ct'] .open .dropdown-toggle.btn-fill.btn-default {\n  border-color: #ffffff;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n.navbar-transparent .dropdown-menu .divider {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.nav-open .nav .caret {\n  border-bottom-color: #ffffff;\n  border-top-color: #ffffff;\n}\n\n.navbar-default {\n  background-color: rgba(255, 255, 255, 0.96);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.navbar-default .navbar-nav > li > a:not(.btn) {\n  color: #9a9a9a;\n}\n.navbar-default .navbar-nav > .active > a,\n.navbar-default .navbar-nav > .active > a:not(.btn):hover,\n.navbar-default .navbar-nav > .active > a:not(.btn):focus,\n.navbar-default .navbar-nav > li > a:not(.btn):hover,\n.navbar-default .navbar-nav > li > a:not(.btn):focus {\n  background-color: transparent;\n  border-radius: 3px;\n  color: #1dc7ea;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.navbar-default .navbar-nav > .dropdown > a:hover .caret,\n.navbar-default .navbar-nav > .dropdown > a:focus .caret {\n  border-bottom-color: #1dc7ea;\n  border-top-color: #1dc7ea;\n}\n.navbar-default .navbar-nav > .open > a,\n.navbar-default .navbar-nav > .open > a:hover,\n.navbar-default .navbar-nav > .open > a:focus {\n  background-color: transparent;\n  color: #1dc7ea;\n}\n.navbar-default .navbar-nav .navbar-toggle:hover,\n.navbar-default .navbar-nav .navbar-toggle:focus {\n  background-color: transparent;\n}\n.navbar-default:not(.navbar-transparent) .btn-default:hover {\n  color: #1dc7ea;\n  border-color: #1dc7ea;\n}\n.navbar-default:not(.navbar-transparent) .btn-neutral,\n.navbar-default:not(.navbar-transparent) .btn-neutral:hover,\n.navbar-default:not(.navbar-transparent) .btn-neutral:active {\n  color: #9a9a9a;\n}\n\n/*      Navbar with icons            */\n.navbar-icons.navbar .navbar-brand {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.navbar-icons .navbar-nav > li > a {\n  text-align: center;\n  padding: 6px 15px;\n  margin: 6px 3px;\n}\n\n.navbar-icons .navbar-nav [class^='pe'] {\n  font-size: 30px;\n  position: relative;\n}\n\n.navbar-icons .navbar-nav p {\n  margin: 3px 0 0;\n}\n\n.navbar-form {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.navbar-form .form-control {\n  border-radius: 0;\n  border: 0;\n  padding: 0;\n  background-color: transparent;\n  height: 22px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #e3e3e3;\n}\n.navbar-transparent .navbar-form .form-control,\n[class*='navbar-ct'] .navbar-form .form-control {\n  color: #ffffff;\n  border: 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.6);\n}\n\n.navbar-ct-blue {\n  background-color: #4ea7ff;\n}\n\n.navbar-ct-azure {\n  background-color: #63d8f1;\n}\n\n.navbar-ct-green {\n  background-color: #a1e82c;\n}\n\n.navbar-ct-orange {\n  background-color: #ffbc67;\n}\n\n.navbar-ct-red {\n  background-color: #fc727a;\n}\n\n.navbar-transparent {\n  padding-top: 15px;\n  background-color: transparent;\n  border-bottom: 1px solid transparent;\n}\n\n.navbar-toggle {\n  margin-top: 19px;\n  margin-bottom: 19px;\n  border: 0;\n}\n.navbar-toggle .icon-bar {\n  background-color: #ffffff;\n}\n.navbar-toggle .navbar-collapse,\n.navbar-toggle .navbar-form {\n  border-color: transparent;\n}\n.navbar-toggle.navbar-default .navbar-toggle:hover,\n.navbar-toggle.navbar-default .navbar-toggle:focus {\n  background-color: transparent;\n}\n\n.footer {\n  background-color: #ffffff;\n  line-height: 20px;\n}\n.footer nav > ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-weight: normal;\n}\n.footer nav > ul a:not(.btn) {\n  color: #9a9a9a;\n  display: block;\n  margin-bottom: 3px;\n}\n.footer nav > ul a:not(.btn):hover,\n.footer nav > ul a:not(.btn):focus {\n  color: #777777;\n}\n.footer .social-area {\n  padding: 15px 0;\n}\n.footer .social-area h5 {\n  padding-bottom: 15px;\n}\n.footer .social-area > a:not(.btn) {\n  color: #9a9a9a;\n  display: inline-block;\n  vertical-align: top;\n  padding: 10px 5px;\n  font-size: 20px;\n  font-weight: normal;\n  line-height: 20px;\n  text-align: center;\n}\n.footer .social-area > a:not(.btn):hover,\n.footer .social-area > a:not(.btn):focus {\n  color: #777777;\n}\n.footer .copyright {\n  color: #777777;\n  padding: 10px 15px;\n  margin: 10px 3px;\n  line-height: 20px;\n  font-size: 14px;\n}\n.footer hr {\n  border-color: #dddddd;\n}\n.footer .title {\n  color: #777777;\n}\n\n.footer-default {\n  background-color: #f5f5f5;\n}\n\n.footer:not(.footer-big) nav > ul {\n  font-size: 14px;\n}\n.footer:not(.footer-big) nav > ul li {\n  margin-left: 20px;\n  float: left;\n}\n.footer:not(.footer-big) nav > ul a {\n  padding: 10px 0px;\n  margin: 10px 10px 10px 0px;\n}\n\n.dropdown-menu {\n  visibility: hidden;\n  margin: 0;\n  padding: 0;\n  border-radius: 10px;\n  display: block;\n  z-index: 9000;\n  position: absolute;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  -webkit-box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);\n  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);\n}\n.open .dropdown-menu {\n  opacity: 1;\n  filter: alpha(opacity=100);\n  visibility: visible;\n}\n.select .dropdown-menu {\n  border-radius: 0 0 10px 10px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-transform-origin: 50% -40px;\n  -moz-transform-origin: 50% -40px;\n  -o-transform-origin: 50% -40px;\n  -ms-transform-origin: 50% -40px;\n  transform-origin: 50% -40px;\n  -webkit-transform: scale(1);\n  -moz-transform: scale(1);\n  -o-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition: all 150ms linear;\n  -moz-transition: all 150ms linear;\n  -o-transition: all 150ms linear;\n  -ms-transition: all 150ms linear;\n  transition: all 150ms linear;\n  margin-top: -20px;\n}\n.select.open .dropdown-menu {\n  margin-top: -1px;\n}\n.dropdown-menu > li > a {\n  padding: 8px 16px;\n  color: #333333;\n}\n.dropdown-menu > li > a img {\n  margin-top: -3px;\n}\n.dropdown-menu > li > a:focus {\n  outline: 0 !important;\n}\n.btn-group.select .dropdown-menu {\n  min-width: 100%;\n}\n.dropdown-menu > li:first-child > a {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n.dropdown-menu > li:last-child > a {\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n.select .dropdown-menu > li:first-child > a {\n  border-radius: 0;\n  border-bottom: 0 none;\n}\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus {\n  background-color: #f5f5f5;\n  color: #333333;\n  opacity: 1;\n  text-decoration: none;\n}\n.dropdown-menu.dropdown-blue > li > a:hover,\n.dropdown-menu.dropdown-blue > li > a:focus {\n  background-color: rgba(52, 114, 247, 0.2);\n}\n.dropdown-menu.dropdown-azure > li > a:hover,\n.dropdown-menu.dropdown-azure > li > a:focus {\n  background-color: rgba(29, 199, 234, 0.2);\n}\n.dropdown-menu.ct-green > li > a:hover,\n.dropdown-menu.ct-green > li > a:focus {\n  background-color: rgba(135, 203, 22, 0.2);\n}\n.dropdown-menu.dropdown-orange > li > a:hover,\n.dropdown-menu.dropdown-orange > li > a:focus {\n  background-color: rgba(255, 149, 0, 0.2);\n}\n.dropdown-menu.dropdown-red > li > a:hover,\n.dropdown-menu.dropdown-red > li > a:focus {\n  background-color: rgba(255, 74, 85, 0.2);\n}\n\n.dropdown-with-icons > li > a {\n  padding-left: 0px;\n  line-height: 28px;\n}\n\n.dropdown-with-icons i {\n  text-align: center;\n  line-height: 28px;\n  float: left;\n}\n.dropdown-with-icons i[class^='pe-'] {\n  font-size: 24px;\n  width: 46px;\n}\n.dropdown-with-icons i[class^='fa'] {\n  font-size: 14px;\n  width: 38px;\n}\n\n.btn-group.select {\n  overflow: hidden;\n}\n\n.btn-group.select.open {\n  overflow: visible;\n}\n\n.card {\n  border-radius: 4px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(63, 63, 68, 0.1);\n  background-color: #ffffff;\n  margin-bottom: 30px;\n}\n.card .image {\n  width: 100%;\n  overflow: hidden;\n  height: 260px;\n  border-radius: 4px 4px 0 0;\n  position: relative;\n  -webkit-transform-style: preserve-3d;\n  -moz-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n}\n.card .image img {\n  width: 100%;\n}\n.card .filter {\n  position: absolute;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.68);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n.card .filter .btn {\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.card:hover .filter {\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.card .btn-hover {\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n.card:hover .btn-hover {\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.card .content {\n  padding: 15px 15px 10px 15px;\n}\n.card .header {\n  padding: 15px 15px 0;\n}\n.card .category,\n.card label {\n  font-size: 14px;\n  font-weight: 400;\n  color: #9a9a9a;\n  margin-bottom: 0px;\n}\n.card .category i,\n.card label i {\n  font-size: 16px;\n}\n.card label {\n  font-size: 12px;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n}\n.card .title {\n  margin: 0;\n  color: #333333;\n  font-weight: 300;\n}\n.card .avatar {\n  width: 30px;\n  height: 30px;\n  overflow: hidden;\n  border-radius: 50%;\n  margin-right: 5px;\n}\n.card .description {\n  font-size: 14px;\n  color: #333;\n}\n.card .footer {\n  padding: 0;\n  background-color: transparent;\n  line-height: 30px;\n}\n.card .footer .legend {\n  padding: 5px 0;\n}\n.card .footer hr {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.card .stats {\n  color: #a9a9a9;\n}\n.card .footer div {\n  display: inline-block;\n}\n.card .author {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.card .author i {\n  font-size: 14px;\n}\n.card h6 {\n  font-size: 12px;\n  margin: 0;\n}\n.card.card-separator:after {\n  height: 100%;\n  right: -15px;\n  top: 0;\n  width: 1px;\n  background-color: #dddddd;\n  content: '';\n  position: absolute;\n}\n.card .ct-chart {\n  margin: 30px 0 30px;\n  height: 245px;\n}\n.card .table tbody td:first-child,\n.card .table thead th:first-child {\n  padding-left: 15px;\n}\n.card .table tbody td:last-child,\n.card .table thead th:last-child {\n  padding-right: 15px;\n}\n.card .alert {\n  border-radius: 4px;\n  position: relative;\n}\n.card .alert.alert-with-icon {\n  padding-left: 65px;\n}\n\n.card-user .image {\n  height: 110px;\n}\n\n.card-user .image-plain {\n  height: 0;\n  margin-top: 110px;\n}\n\n.card-user .author {\n  text-align: center;\n  text-transform: none;\n  margin-top: -70px;\n}\n\n.card-user .avatar {\n  width: 124px;\n  height: 124px;\n  border: 5px solid #ffffff;\n  position: relative;\n  margin-bottom: 15px;\n}\n.card-user .avatar.border-gray {\n  border-color: #eeeeee;\n}\n\n.card-user .title {\n  line-height: 24px;\n}\n\n.card-user .content {\n  min-height: 240px;\n}\n\n.card-user .footer,\n.card-price .footer {\n  padding: 5px 15px 10px;\n}\n\n.card-user hr,\n.card-price hr {\n  margin: 5px 15px;\n}\n\n.card-plain {\n  background-color: transparent;\n  box-shadow: none;\n  border-radius: 0;\n}\n.card-plain .image {\n  border-radius: 4px;\n}\n\n.card-stats .icon-big {\n  font-size: 3em;\n  min-height: 64px;\n}\n.card-stats .icon-big i {\n  font-weight: bold;\n  line-height: 59px;\n}\n\n.card-stats .numbers {\n  font-size: 2em;\n  text-align: right;\n}\n.card-stats .numbers p {\n  margin: 0;\n}\n\n.ct-label {\n  fill: rgba(0, 0, 0, 0.4);\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 1.3rem;\n  line-height: 1;\n}\n\n.ct-chart-line .ct-label,\n.ct-chart-bar .ct-label {\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n.ct-label.ct-horizontal.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-label.ct-vertical.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  justify-content: flex-end;\n  text-align: right;\n  text-anchor: end;\n}\n\n.ct-label.ct-vertical.ct-end {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-chart-bar .ct-label.ct-horizontal.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  text-anchor: start;\n}\n\n.ct-chart-bar .ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  text-anchor: start;\n}\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  justify-content: flex-end;\n  text-align: right;\n  text-anchor: end;\n}\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: end;\n}\n\n.ct-grid {\n  stroke: rgba(0, 0, 0, 0.2);\n  stroke-width: 1px;\n  stroke-dasharray: 2px;\n}\n\n.ct-point {\n  stroke-width: 8px;\n  stroke-linecap: round;\n}\n\n.ct-line {\n  fill: none;\n  stroke-width: 3px;\n}\n\n.ct-area {\n  stroke: none;\n  fill-opacity: 0.8;\n}\n\n.ct-bar {\n  fill: none;\n  stroke-width: 10px;\n}\n\n.ct-slice-donut {\n  fill: none;\n  stroke-width: 60px;\n}\n\n.ct-series-a .ct-point,\n.ct-series-a .ct-line,\n.ct-series-a .ct-bar,\n.ct-series-a .ct-slice-donut {\n  stroke: #1dc7ea;\n}\n\n.ct-series-a .ct-slice-pie,\n.ct-series-a .ct-area {\n  fill: #1dc7ea;\n}\n\n.ct-series-b .ct-point,\n.ct-series-b .ct-line,\n.ct-series-b .ct-bar,\n.ct-series-b .ct-slice-donut {\n  stroke: #fb404b;\n}\n\n.ct-series-b .ct-slice-pie,\n.ct-series-b .ct-area {\n  fill: #fb404b;\n}\n\n.ct-series-c .ct-point,\n.ct-series-c .ct-line,\n.ct-series-c .ct-bar,\n.ct-series-c .ct-slice-donut {\n  stroke: #ffa534;\n}\n\n.ct-series-c .ct-slice-pie,\n.ct-series-c .ct-area {\n  fill: #ffa534;\n}\n\n.ct-series-d .ct-point,\n.ct-series-d .ct-line,\n.ct-series-d .ct-bar,\n.ct-series-d .ct-slice-donut {\n  stroke: #9368e9;\n}\n\n.ct-series-d .ct-slice-pie,\n.ct-series-d .ct-area {\n  fill: #9368e9;\n}\n\n.ct-series-e .ct-point,\n.ct-series-e .ct-line,\n.ct-series-e .ct-bar,\n.ct-series-e .ct-slice-donut {\n  stroke: #87cb16;\n}\n\n.ct-series-e .ct-slice-pie,\n.ct-series-e .ct-area {\n  fill: #87cb16;\n}\n\n.ct-series-f .ct-point,\n.ct-series-f .ct-line,\n.ct-series-f .ct-bar,\n.ct-series-f .ct-slice-donut {\n  stroke: #1b8dff;\n}\n\n.ct-series-f .ct-slice-pie,\n.ct-series-f .ct-area {\n  fill: #1b8dff;\n}\n\n.ct-series-g .ct-point,\n.ct-series-g .ct-line,\n.ct-series-g .ct-bar,\n.ct-series-g .ct-slice-donut {\n  stroke: #5e5e5e;\n}\n\n.ct-series-g .ct-slice-pie,\n.ct-series-g .ct-area {\n  fill: #5e5e5e;\n}\n\n.ct-series-h .ct-point,\n.ct-series-h .ct-line,\n.ct-series-h .ct-bar,\n.ct-series-h .ct-slice-donut {\n  stroke: #dd4b39;\n}\n\n.ct-series-h .ct-slice-pie,\n.ct-series-h .ct-area {\n  fill: #dd4b39;\n}\n\n.ct-series-i .ct-point,\n.ct-series-i .ct-line,\n.ct-series-i .ct-bar,\n.ct-series-i .ct-slice-donut {\n  stroke: #35465c;\n}\n\n.ct-series-i .ct-slice-pie,\n.ct-series-i .ct-area {\n  fill: #35465c;\n}\n\n.ct-series-j .ct-point,\n.ct-series-j .ct-line,\n.ct-series-j .ct-bar,\n.ct-series-j .ct-slice-donut {\n  stroke: #e52d27;\n}\n\n.ct-series-j .ct-slice-pie,\n.ct-series-j .ct-area {\n  fill: #e52d27;\n}\n\n.ct-series-k .ct-point,\n.ct-series-k .ct-line,\n.ct-series-k .ct-bar,\n.ct-series-k .ct-slice-donut {\n  stroke: #55acee;\n}\n\n.ct-series-k .ct-slice-pie,\n.ct-series-k .ct-area {\n  fill: #55acee;\n}\n\n.ct-series-l .ct-point,\n.ct-series-l .ct-line,\n.ct-series-l .ct-bar,\n.ct-series-l .ct-slice-donut {\n  stroke: #cc2127;\n}\n\n.ct-series-l .ct-slice-pie,\n.ct-series-l .ct-area {\n  fill: #cc2127;\n}\n\n.ct-series-m .ct-point,\n.ct-series-m .ct-line,\n.ct-series-m .ct-bar,\n.ct-series-m .ct-slice-donut {\n  stroke: #1769ff;\n}\n\n.ct-series-m .ct-slice-pie,\n.ct-series-m .ct-area {\n  fill: #1769ff;\n}\n\n.ct-series-n .ct-point,\n.ct-series-n .ct-line,\n.ct-series-n .ct-bar,\n.ct-series-n .ct-slice-donut {\n  stroke: #6188e2;\n}\n\n.ct-series-n .ct-slice-pie,\n.ct-series-n .ct-area {\n  fill: #6188e2;\n}\n\n.ct-series-o .ct-point,\n.ct-series-o .ct-line,\n.ct-series-o .ct-bar,\n.ct-series-o .ct-slice-donut {\n  stroke: #a748ca;\n}\n\n.ct-series-o .ct-slice-pie,\n.ct-series-o .ct-area {\n  fill: #a748ca;\n}\n\n.ct-square {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-square:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 100%;\n}\n.ct-square:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-square > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-minor-second {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-second:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 93.75%;\n}\n.ct-minor-second:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-minor-second > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-second {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-second:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 88.88889%;\n}\n.ct-major-second:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-major-second > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-minor-third {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-third:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 83.33333%;\n}\n.ct-minor-third:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-minor-third > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-third {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-third:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 80%;\n}\n.ct-major-third:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-major-third > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-perfect-fourth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-perfect-fourth:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 75%;\n}\n.ct-perfect-fourth:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-perfect-fourth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-perfect-fifth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-perfect-fifth:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 66.66667%;\n}\n.ct-perfect-fifth:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-perfect-fifth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-minor-sixth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-sixth:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 62.5%;\n}\n.ct-minor-sixth:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-minor-sixth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-golden-section {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-golden-section:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 61.8047%;\n}\n.ct-golden-section:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-golden-section > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-sixth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-sixth:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 60%;\n}\n.ct-major-sixth:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-major-sixth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-minor-seventh {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-seventh:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 56.25%;\n}\n.ct-minor-seventh:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-minor-seventh > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-seventh {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-seventh:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 53.33333%;\n}\n.ct-major-seventh:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-major-seventh > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-octave {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-octave:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 50%;\n}\n.ct-octave:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-octave > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-tenth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-tenth:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 40%;\n}\n.ct-major-tenth:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-major-tenth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-eleventh {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-eleventh:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 37.5%;\n}\n.ct-major-eleventh:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-major-eleventh > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-twelfth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-twelfth:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 33.33333%;\n}\n.ct-major-twelfth:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-major-twelfth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-double-octave {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-double-octave:before {\n  display: block;\n  float: left;\n  content: '';\n  width: 0;\n  height: 0;\n  padding-bottom: 25%;\n}\n.ct-double-octave:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.ct-double-octave > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n@media (min-width: 992px) {\n  .navbar-form {\n    margin-top: 21px;\n    margin-bottom: 21px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n  .navbar-nav > li > .dropdown-menu,\n  .dropdown .dropdown-menu {\n    -webkit-transform: scale(0);\n    -moz-transform: scale(0);\n    -o-transform: scale(0);\n    -ms-transform: scale(0);\n    transform: scale(0);\n    -webkit-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n    -moz-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n    -o-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n    -ms-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n    transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n  }\n  .navbar-nav > li.open > .dropdown-menu,\n  .dropdown.open .dropdown-menu {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -o-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1);\n    -webkit-transform-origin: 29px -50px;\n    -moz-transform-origin: 29px -50px;\n    -o-transform-origin: 29px -50px;\n    -ms-transform-origin: 29px -50px;\n    transform-origin: 29px -50px;\n  }\n  .navbar-nav > li > .dropdown-menu:before {\n    border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: '';\n    display: inline-block;\n    position: absolute;\n    left: 12px;\n    top: -11px;\n  }\n  .navbar-nav > li > .dropdown-menu:after {\n    border-bottom: 11px solid #ffffff;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: '';\n    display: inline-block;\n    position: absolute;\n    left: 12px;\n    top: -10px;\n  }\n  .navbar-nav.navbar-right > li > .dropdown-menu:before {\n    left: auto;\n    right: 12px;\n  }\n  .navbar-nav.navbar-right > li > .dropdown-menu:after {\n    left: auto;\n    right: 12px;\n  }\n  .footer:not(.footer-big) nav > ul li:first-child {\n    margin-left: 0;\n  }\n  body > .navbar-collapse.collapse {\n    display: none !important;\n  }\n  .card form [class*='col-'] {\n    padding: 6px;\n  }\n  .card form [class*='col-']:first-child {\n    padding-left: 15px;\n  }\n  .card form [class*='col-']:last-child {\n    padding-right: 15px;\n  }\n}\n\n/*          Changes for small display      */\n@media (max-width: 991px) {\n  .main-panel {\n    width: 100%;\n  }\n  .navbar-transparent {\n    padding-top: 15px;\n    background-color: rgba(0, 0, 0, 0.45);\n  }\n  body {\n    position: relative;\n  }\n  .main-panel {\n    -webkit-transform: translate3d(0px, 0, 0);\n    -moz-transform: translate3d(0px, 0, 0);\n    -o-transform: translate3d(0px, 0, 0);\n    -ms-transform: translate3d(0px, 0, 0);\n    transform: translate3d(0px, 0, 0);\n    -webkit-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -moz-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -o-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -ms-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    left: 0;\n  }\n  .navbar .container {\n    left: 0;\n    width: 100%;\n    -webkit-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -moz-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -o-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -ms-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    position: relative;\n  }\n  .navbar .navbar-collapse.collapse,\n  .navbar .navbar-collapse.collapse.in,\n  .navbar .navbar-collapse.collapsing {\n    display: none !important;\n  }\n  .navbar-nav > li {\n    float: none;\n    position: relative;\n    display: block;\n  }\n  .sidebar {\n    position: fixed;\n    display: block;\n    top: 0;\n    height: 100%;\n    width: 260px;\n    right: 0;\n    left: auto;\n    z-index: 1032;\n    visibility: visible;\n    background-color: #999;\n    overflow-y: visible;\n    border-top: none;\n    text-align: left;\n    padding: 0;\n    -webkit-transform: translate3d(260px, 0, 0);\n    -moz-transform: translate3d(260px, 0, 0);\n    -o-transform: translate3d(260px, 0, 0);\n    -ms-transform: translate3d(260px, 0, 0);\n    transform: translate3d(260px, 0, 0);\n    -webkit-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -moz-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -o-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -ms-transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  }\n  .sidebar > ul {\n    position: relative;\n    z-index: 4;\n    overflow-y: scroll;\n    height: calc(100vh - 61px);\n    width: 100%;\n  }\n  .sidebar::before {\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    background-color: #282828;\n    display: block;\n    content: '';\n    z-index: 1;\n  }\n  .sidebar .sidebar-wrapper .dropdown-menu > li:first-child > a,\n  .sidebar .sidebar-wrapper .dropdown-menu > li:last-child > a {\n    border-radius: 4px;\n  }\n  .sidebar .sidebar-wrapper .dropdown-menu > li > a:hover,\n  .sidebar .sidebar-wrapper .dropdown-menu > li > a:focus {\n    color: white;\n  }\n  .sidebar .sidebar-wrapper > .nav > div .nav {\n    margin-top: 10px;\n    float: none !important;\n  }\n  .sidebar .sidebar-wrapper > .nav > div .nav > li > a {\n    margin: 0;\n    line-height: 30px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    margin: 5px 15px;\n  }\n  .sidebar .sidebar-wrapper > .nav > div .notification {\n    float: left;\n    line-height: 30px;\n    margin-right: 8px;\n    font-weight: 600;\n  }\n  .sidebar .open .dropdown-menu {\n    position: static;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    background-color: transparent;\n    border: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n  .nav-open .sidebar {\n    -webkit-transform: translate3d(0px, 0, 0);\n    -moz-transform: translate3d(0px, 0, 0);\n    -o-transform: translate3d(0px, 0, 0);\n    -ms-transform: translate3d(0px, 0, 0);\n    transform: translate3d(0px, 0, 0);\n  }\n  .nav-open .navbar .container {\n    left: -260px;\n  }\n  .nav-open .main-panel {\n    left: 0;\n    -webkit-transform: translate3d(-260px, 0, 0);\n    -moz-transform: translate3d(-260px, 0, 0);\n    -o-transform: translate3d(-260px, 0, 0);\n    -ms-transform: translate3d(-260px, 0, 0);\n    transform: translate3d(-260px, 0, 0);\n  }\n  .navbar-toggle .icon-bar {\n    display: block;\n    position: relative;\n    background: #fff;\n    width: 24px;\n    height: 2px;\n    border-radius: 1px;\n    margin: 0 auto;\n  }\n  .navbar-header .navbar-toggle {\n    margin: 10px 15px 10px 0;\n    width: 40px;\n    height: 40px;\n  }\n  .bar1,\n  .bar2,\n  .bar3 {\n    outline: 1px solid transparent;\n  }\n  .bar1 {\n    top: 0px;\n    -webkit-animation: topbar-back 500ms linear 0s;\n    -moz-animation: topbar-back 500ms linear 0s;\n    animation: topbar-back 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  .bar2 {\n    opacity: 1;\n  }\n  .bar3 {\n    bottom: 0px;\n    -webkit-animation: bottombar-back 500ms linear 0s;\n    -moz-animation: bottombar-back 500ms linear 0s;\n    animation: bottombar-back 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  .toggled .bar1 {\n    top: 6px;\n    -webkit-animation: topbar-x 500ms linear 0s;\n    -moz-animation: topbar-x 500ms linear 0s;\n    animation: topbar-x 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  .toggled .bar2 {\n    opacity: 0;\n  }\n  .toggled .bar3 {\n    bottom: 6px;\n    -webkit-animation: bottombar-x 500ms linear 0s;\n    -moz-animation: bottombar-x 500ms linear 0s;\n    animation: bottombar-x 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  @keyframes topbar-x {\n    0% {\n      top: 0px;\n      transform: rotate(0deg);\n    }\n    45% {\n      top: 6px;\n      transform: rotate(145deg);\n    }\n    75% {\n      transform: rotate(130deg);\n    }\n    100% {\n      transform: rotate(135deg);\n    }\n  }\n  @-webkit-keyframes topbar-x {\n    0% {\n      top: 0px;\n      -webkit-transform: rotate(0deg);\n    }\n    45% {\n      top: 6px;\n      -webkit-transform: rotate(145deg);\n    }\n    75% {\n      -webkit-transform: rotate(130deg);\n    }\n    100% {\n      -webkit-transform: rotate(135deg);\n    }\n  }\n  @-moz-keyframes topbar-x {\n    0% {\n      top: 0px;\n      -moz-transform: rotate(0deg);\n    }\n    45% {\n      top: 6px;\n      -moz-transform: rotate(145deg);\n    }\n    75% {\n      -moz-transform: rotate(130deg);\n    }\n    100% {\n      -moz-transform: rotate(135deg);\n    }\n  }\n  @keyframes topbar-back {\n    0% {\n      top: 6px;\n      transform: rotate(135deg);\n    }\n    45% {\n      transform: rotate(-10deg);\n    }\n    75% {\n      transform: rotate(5deg);\n    }\n    100% {\n      top: 0px;\n      transform: rotate(0);\n    }\n  }\n  @-webkit-keyframes topbar-back {\n    0% {\n      top: 6px;\n      -webkit-transform: rotate(135deg);\n    }\n    45% {\n      -webkit-transform: rotate(-10deg);\n    }\n    75% {\n      -webkit-transform: rotate(5deg);\n    }\n    100% {\n      top: 0px;\n      -webkit-transform: rotate(0);\n    }\n  }\n  @-moz-keyframes topbar-back {\n    0% {\n      top: 6px;\n      -moz-transform: rotate(135deg);\n    }\n    45% {\n      -moz-transform: rotate(-10deg);\n    }\n    75% {\n      -moz-transform: rotate(5deg);\n    }\n    100% {\n      top: 0px;\n      -moz-transform: rotate(0);\n    }\n  }\n  @keyframes bottombar-x {\n    0% {\n      bottom: 0px;\n      transform: rotate(0deg);\n    }\n    45% {\n      bottom: 6px;\n      transform: rotate(-145deg);\n    }\n    75% {\n      transform: rotate(-130deg);\n    }\n    100% {\n      transform: rotate(-135deg);\n    }\n  }\n  @-webkit-keyframes bottombar-x {\n    0% {\n      bottom: 0px;\n      -webkit-transform: rotate(0deg);\n    }\n    45% {\n      bottom: 6px;\n      -webkit-transform: rotate(-145deg);\n    }\n    75% {\n      -webkit-transform: rotate(-130deg);\n    }\n    100% {\n      -webkit-transform: rotate(-135deg);\n    }\n  }\n  @-moz-keyframes bottombar-x {\n    0% {\n      bottom: 0px;\n      -moz-transform: rotate(0deg);\n    }\n    45% {\n      bottom: 6px;\n      -moz-transform: rotate(-145deg);\n    }\n    75% {\n      -moz-transform: rotate(-130deg);\n    }\n    100% {\n      -moz-transform: rotate(-135deg);\n    }\n  }\n  @keyframes bottombar-back {\n    0% {\n      bottom: 6px;\n      transform: rotate(-135deg);\n    }\n    45% {\n      transform: rotate(10deg);\n    }\n    75% {\n      transform: rotate(-5deg);\n    }\n    100% {\n      bottom: 0px;\n      transform: rotate(0);\n    }\n  }\n  @-webkit-keyframes bottombar-back {\n    0% {\n      bottom: 6px;\n      -webkit-transform: rotate(-135deg);\n    }\n    45% {\n      -webkit-transform: rotate(10deg);\n    }\n    75% {\n      -webkit-transform: rotate(-5deg);\n    }\n    100% {\n      bottom: 0px;\n      -webkit-transform: rotate(0);\n    }\n  }\n  @-moz-keyframes bottombar-back {\n    0% {\n      bottom: 6px;\n      -moz-transform: rotate(-135deg);\n    }\n    45% {\n      -moz-transform: rotate(10deg);\n    }\n    75% {\n      -moz-transform: rotate(-5deg);\n    }\n    100% {\n      bottom: 0px;\n      -moz-transform: rotate(0);\n    }\n  }\n  @-webkit-keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  @-moz-keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  .dropdown-menu .divider {\n    background-color: rgba(229, 229, 229, 0.15);\n  }\n  .navbar-nav {\n    margin: 1px 0;\n  }\n  .navbar-nav .open .dropdown-menu > li > a {\n    padding: 15px 15px 5px 50px;\n  }\n  .navbar-nav .open .dropdown-menu > li:first-child > a {\n    padding: 5px 15px 5px 50px;\n  }\n  .navbar-nav .open .dropdown-menu > li:last-child > a {\n    padding: 15px 15px 25px 50px;\n  }\n  [class*='navbar-'] .navbar-nav > li > a,\n  [class*='navbar-'] .navbar-nav > li > a:hover,\n  [class*='navbar-'] .navbar-nav > li > a:focus,\n  [class*='navbar-'] .navbar-nav .active > a,\n  [class*='navbar-'] .navbar-nav .active > a:hover,\n  [class*='navbar-'] .navbar-nav .active > a:focus,\n  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a,\n  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a:hover,\n  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a:focus,\n  [class*='navbar-']\n    .navbar-nav\n    .navbar-nav\n    .open\n    .dropdown-menu\n    > li\n    > a:active {\n    color: white;\n  }\n  [class*='navbar-'] .navbar-nav > li > a,\n  [class*='navbar-'] .navbar-nav > li > a:hover,\n  [class*='navbar-'] .navbar-nav > li > a:focus,\n  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a,\n  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a:hover,\n  [class*='navbar-'] .navbar-nav .open .dropdown-menu > li > a:focus {\n    opacity: 0.7;\n    background: transparent;\n  }\n  [class*='navbar-']\n    .navbar-nav.navbar-nav\n    .open\n    .dropdown-menu\n    > li\n    > a:active {\n    opacity: 1;\n  }\n  [class*='navbar-'] .navbar-nav .dropdown > a:hover .caret {\n    border-bottom-color: #777;\n    border-top-color: #777;\n  }\n  [class*='navbar-'] .navbar-nav .dropdown > a:active .caret {\n    border-bottom-color: white;\n    border-top-color: white;\n  }\n  .dropdown-menu {\n    display: none;\n  }\n  .navbar-fixed-top {\n    -webkit-backface-visibility: hidden;\n  }\n  #bodyClick {\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 0;\n    top: 0;\n    left: auto;\n    right: 250px;\n    content: '';\n    z-index: 9999;\n    overflow-x: hidden;\n  }\n  .social-line .btn {\n    margin: 0 0 10px 0;\n  }\n  .subscribe-line .form-control {\n    margin: 0 0 10px 0;\n  }\n  .social-line.pull-right {\n    float: none;\n  }\n  .footer nav.pull-left {\n    float: none !important;\n  }\n  .footer:not(.footer-big) nav > ul li {\n    float: none;\n  }\n  .social-area.pull-right {\n    float: none !important;\n  }\n  .form-control + .form-control-feedback {\n    margin-top: -8px;\n  }\n  .navbar-toggle:hover,\n  .navbar-toggle:focus {\n    background-color: transparent !important;\n  }\n  .btn.dropdown-toggle {\n    margin-bottom: 0;\n  }\n  .media-post .author {\n    width: 20%;\n    float: none !important;\n    display: block;\n    margin: 0 auto 10px;\n  }\n  .media-post .media-body {\n    width: 100%;\n  }\n  .navbar-collapse.collapse {\n    height: 100% !important;\n  }\n  .navbar-collapse.collapse.in {\n    display: block;\n  }\n  .navbar-header .collapse,\n  .navbar-toggle {\n    display: block !important;\n  }\n  .navbar-header {\n    float: none;\n  }\n  .navbar-nav .open .dropdown-menu {\n    position: static;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    background-color: transparent;\n    border: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n  .navbar-collapse .nav p {\n    font-size: 14px;\n    margin: 0;\n  }\n  .navbar-collapse [class^='pe-7s-'] {\n    float: left;\n    font-size: 20px;\n    margin-right: 10px;\n  }\n}\n\n@media (min-width: 992px) {\n  .table-full-width {\n    margin-left: -15px;\n    margin-right: -15px;\n  }\n  .table-responsive {\n    overflow: visible;\n  }\n}\n\n@media (max-width: 991px) {\n  .table-responsive {\n    width: 100%;\n    margin-bottom: 15px;\n    overflow-x: scroll;\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
